// import { useEffect, useState, useRef, useCallback } from "react";
// import {
//   Tabs,
//   Tab,
//   Box,
//   Button,
//   CircularProgress,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   Paper,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   TextField,
//   InputAdornment,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Select,
//   Chip,
//   Divider,
//   Alert,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Tooltip,
//   ToggleButton,
//   ToggleButtonGroup
// } from "@mui/material";
// import {
//   PictureAsPdf as PdfIcon,
//   Search as SearchIcon,
//   Clear as ClearIcon,
//   WarningAmber as WarningIcon,
//   CheckCircle as CheckCircleIcon,
//   Download as DownloadIcon,
//   Visibility as VisibilityIcon,
//   Print as PrintIcon,
//   Payment as PaymentIcon,
//   Close as CloseIcon,
//   BarChart as BarChartIcon,
//   ShowChart as ShowChartIcon,
//   PieChart as PieChartIcon,
//   TrendingUp as TrendingUpIcon,
//   Timeline as TimelineIcon
// } from "@mui/icons-material";
// import { format } from "date-fns";
// import { ExecutePostWithParams, GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

// // Helper function to normalize currency values
// const normalizeCurrency = (paymentMode) => {
//   if (!paymentMode) return "unknown";
//   const mode = paymentMode.toLowerCase();
//   if (mode === "usd") return "usd";
//   if (mode === "birr" || mode === "etb") return "birr";
//   return mode;
// };

// // Tab Panel Component
// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`revenue-tabpanel-${index}`}
//       aria-labelledby={`revenue-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// export default function RevenueReport() {
//   // State Management
//   const [tabValue, setTabValue] = useState(0);
//   const [revenueData, setRevenueData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
  
//   // Filter States
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedPark, setSelectedPark] = useState("all");
//   const [selectedStatus, setSelectedStatus] = useState("all");
//   const [selectedCurrency, setSelectedCurrency] = useState("all");
//   const [selectedYear, setSelectedYear] = useState("all");
//   const [selectedMonth, setSelectedMonth] = useState("all");
  
//   // Year Range and Month Range States
//   const [startYear, setStartYear] = useState("all");
//   const [endYear, setEndYear] = useState("all");
//   const [startMonth, setStartMonth] = useState("all");
//   const [endMonth, setEndMonth] = useState("all");
  
//   const [parksList, setParksList] = useState([]);
  
//   // Chart States
//   const [chartType, setChartType] = useState('bar');
//   const [showChart, setShowChart] = useState(false);
//   const [chartCurrency, setChartCurrency] = useState('both');
//   const [showYearlyChart, setShowYearlyChart] = useState(false);
//   const [selectedParkForYearly, setSelectedParkForYearly] = useState("all");
  
//   // Dialog States
//   const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
//   const [selectedRevenue, setSelectedRevenue] = useState(null);

//   // Years and Months for filtering
//   // Generate last 10 years dynamically
// const getLastNYears = (n) => {
//     const currentYear = new Date().getFullYear();
//     const years = ["all"];
//     for (let i = 0; i < n; i++) {
//       years.push((currentYear - i).toString());
//     }
//     return years;
//   };
  
//   // Usage in your component
//   const years = getLastNYears(10);
//   const months = [
//     { value: "all", label: "All Months" },
//     { value: "01", label: "January" },
//     { value: "02", label: "February" },
//     { value: "03", label: "March" },
//     { value: "04", label: "April" },
//     { value: "05", label: "May" },
//     { value: "06", label: "June" },
//     { value: "07", label: "July" },
//     { value: "08", label: "August" },
//     { value: "09", label: "September" },
//     { value: "10", label: "October" },
//     { value: "11", label: "November" },
//     { value: "12", label: "December" }
//   ];

//   // Utility Functions
//   const formatCurrency = (amount, paymentMode) => {
//     const formatted = formatNumber(amount);
//     const normalizedMode = normalizeCurrency(paymentMode);
    
//     if (normalizedMode === "usd") {
//       return `$${formatted}`;
//     } else {
//       return `${formatted} ETB`;
//     }
//   };

//   const formatNumber = (number) => {
//     let num = 0;
    
//     if (number !== null && number !== undefined) {
//       if (typeof number === 'string') {
//         const cleaned = number.replace(/[$,]/g, '');
//         num = parseFloat(cleaned);
//       } else {
//         num = parseFloat(number);
//       }
      
//       if (isNaN(num)) {
//         num = 0;
//       }
//     }
    
//     return new Intl.NumberFormat('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(num);
//   };

//   const formatDate = (date) => {
//     if (!date) return "N/A";
//     try {
//       return format(new Date(date), 'dd/MM/yyyy');
//     } catch {
//       return "Invalid Date";
//     }
//   };

//   // Fetch revenue data from API
//   useEffect(() => {
//     const fetchRevenue = async () => {
//       setLoading(true);
//       try {
//         const resultData = await GetDataFromApiWithParams(`finances/revenuereport`);
//         console.log("Revenue Response:", resultData);
        
//         let dataArray = [];
//         if (resultData && Array.isArray(resultData)) {
//           dataArray = resultData;
//         } else if (resultData && resultData.data && Array.isArray(resultData.data)) {
//           dataArray = resultData.data;
//         } else if (resultData && resultData.results && Array.isArray(resultData.results)) {
//           dataArray = resultData.results;
//         } else if (resultData && resultData.items && Array.isArray(resultData.items)) {
//           dataArray = resultData.items;
//         } else if (resultData && resultData.records && Array.isArray(resultData.records)) {
//           dataArray = resultData.records;
//         } else if (resultData && typeof resultData === 'object') {
//           for (let key in resultData) {
//             if (Array.isArray(resultData[key])) {
//               dataArray = resultData[key];
//               console.log(`Found array in property: ${key}`);
//               break;
//             }
//           }
//         }
        
//         console.log("Extracted data array:", dataArray);
        
//         if (dataArray.length > 0) {
//           const formattedData = dataArray.map((item, index) => {
//             let revenueAmount = 0;
            
//             if (item.payment_amount !== undefined && item.payment_amount !== null) {
//               if (typeof item.payment_amount === 'number') {
//                 revenueAmount = item.payment_amount;
//               } else if (typeof item.payment_amount === 'string') {
//                 const cleaned = item.payment_amount.replace(/,/g, '');
//                 revenueAmount = parseFloat(cleaned);
//                 if (isNaN(revenueAmount)) revenueAmount = 0;
//               } else {
//                 revenueAmount = parseFloat(item.payment_amount);
//                 if (isNaN(revenueAmount)) revenueAmount = 0;
//               }
//             }
//             else if (item.amount !== undefined && item.amount !== null) {
//               revenueAmount = parseFloat(item.amount);
//               if (isNaN(revenueAmount)) revenueAmount = 0;
//             } else if (item.revenue !== undefined && item.revenue !== null) {
//               revenueAmount = parseFloat(item.revenue);
//               if (isNaN(revenueAmount)) revenueAmount = 0;
//             }
            
//             let paymentMode = "ETB";
//             if (item.payment_mode) {
//               paymentMode = item.payment_mode;
//             } else if (item.currency) {
//               paymentMode = item.currency;
//             }
            
//             let transactionDate = item.transaction_date || item.date || item.payment_date || item.created_at;
//             let month = item.month;
//             let year = item.year;
            
//             if (transactionDate && !month) {
//               try {
//                 const dateObj = new Date(transactionDate);
//                 if (!isNaN(dateObj.getTime())) {
//                   month = format(dateObj, 'MM');
//                   year = format(dateObj, 'yyyy');
//                 }
//               } catch (e) {
//                 console.warn("Date parsing error:", e);
//               }
//             }
            
//             const formattedAmount = formatCurrency(revenueAmount, paymentMode);
            
//             return {
//               id: item.id || item.revenue_id || item.transaction_id || index,
//               transaction_id: item.transaction_id || item.id || `TRX-${index}`,
//               company_name: item.company_name || item.tenant_name || item.customer_name || "N/A",
//               park_name: item.park || item.park_name || item.location || "N/A",
//               payment_mode: paymentMode,
//               amount: revenueAmount,
//               formattedAmount: formattedAmount,
//               transaction_date: transactionDate,
//               transaction_date_formatted: transactionDate ? formatDate(transactionDate) : "N/A",
//               revenue_type: item.payment_type || item.revenue_type || item.type || item.category || "Rent",
//               payment_status: item.payment_status || item.status || "Completed",
//               tenant_name: item.company_name || item.tenant_name || "N/A",
//               invoice_number: item.invoice_number || item.invoice_no || `INV-${index}`,
//               description: item.description || item.notes || `Revenue from ${item.company_name || 'Unknown'}`,
//               month: month || "01",
//               year: year || "2024",
//               upin: item.upin || "N/A",
//               contact_number: item.contact_number || item.phone || "N/A",
//               email: item.email || "N/A"
//             };
//           });
          
//           console.log("Final formatted data:", formattedData);
//           setRevenueData(formattedData);
//           setFilteredData(formattedData);
          
//           const uniqueParks = [...new Set(formattedData.map(item => item.park_name).filter(Boolean))];
//           setParksList(uniqueParks);
//         } else {
//           console.log("No revenue data received or invalid format");
//           setRevenueData([]);
//           setFilteredData([]);
//         }
//       } catch (error) {
//         console.error("Failed to fetch revenue data:", error);
//         setRevenueData([]);
//         setFilteredData([]);
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchRevenue();
//   }, []);

//   // Calculate summary statistics using normalized currency
//   const summaryStats = {
//     totalRevenue: filteredData.reduce((sum, item) => sum + (item.amount || 0), 0),
//     totalTransactions: filteredData.length,
//     averageTransaction: filteredData.length > 0 ? filteredData.reduce((sum, item) => sum + (item.amount || 0), 0) / filteredData.length : 0,
//     uniqueCompanies: new Set(filteredData.map(item => item.company_name)).size,
//     completedPayments: filteredData.filter(item => item.payment_status === "Completed").length,
//     pendingPayments: filteredData.filter(item => item.payment_status === "Pending").length
//   };

//   const totalUSD = filteredData
//     .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//     .reduce((sum, item) => sum + (item.amount || 0), 0);

//   const totalETB = filteredData
//     .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//     .reduce((sum, item) => sum + (item.amount || 0), 0);

//   // Chart data preparation for combined currencies
//   const getCombinedChartData = () => {
//     const parkData = {};
    
//     filteredData.forEach(item => {
//       if (!parkData[item.park_name]) {
//         parkData[item.park_name] = {
//           usdRevenue: 0,
//           etbRevenue: 0,
//           totalRevenue: 0,
//           transactionCount: 0,
//           usdTransactionCount: 0,
//           etbTransactionCount: 0
//         };
//       }
      
//       const amount = item.amount || 0;
//       const normalizedMode = normalizeCurrency(item.payment_mode);
      
//       if (normalizedMode === "usd") {
//         parkData[item.park_name].usdRevenue += amount;
//         parkData[item.park_name].usdTransactionCount++;
//       } else if (normalizedMode === "birr") {
//         parkData[item.park_name].etbRevenue += amount;
//         parkData[item.park_name].etbTransactionCount++;
//       }
      
//       parkData[item.park_name].totalRevenue += amount;
//       parkData[item.park_name].transactionCount++;
//     });
    
//     return parkData;
//   };

//   const getChartDataByCurrency = (currency) => {
//     const parkData = {};
//     const filteredByCurrency = filteredData.filter(item => {
//       const normalizedMode = normalizeCurrency(item.payment_mode);
//       if (currency.toLowerCase() === 'usd') {
//         return normalizedMode === 'usd';
//       } else {
//         return normalizedMode === 'birr';
//       }
//     });
    
//     filteredByCurrency.forEach(item => {
//       if (!parkData[item.park_name]) {
//         parkData[item.park_name] = {
//           totalRevenue: 0,
//           transactionCount: 0
//         };
//       }
//       parkData[item.park_name].totalRevenue += item.amount || 0;
//       parkData[item.park_name].transactionCount++;
//     });
//     return parkData;
//   };

//   // Prepare yearly chart data by park
//   const getYearlyChartDataByPark = () => {
//     const yearlyData = {};
    
//     filteredData.forEach(item => {
//       const year = item.year;
//       const park = item.park_name;
//       const amount = item.amount || 0;
//       const normalizedMode = normalizeCurrency(item.payment_mode);
      
//       if (!yearlyData[year]) {
//         yearlyData[year] = {};
//       }
      
//       if (!yearlyData[year][park]) {
//         yearlyData[year][park] = {
//           usdRevenue: 0,
//           etbRevenue: 0,
//           totalRevenue: 0
//         };
//       }
      
//       if (normalizedMode === "usd") {
//         yearlyData[year][park].usdRevenue += amount;
//       } else if (normalizedMode === "birr") {
//         yearlyData[year][park].etbRevenue += amount;
//       }
      
//       yearlyData[year][park].totalRevenue += amount;
//     });
    
//     return yearlyData;
//   };

//   // Prepare yearly summary data (total per year by currency)
//   const getYearlySummaryData = () => {
//     const yearlySummary = {};
    
//     filteredData.forEach(item => {
//       const year = item.year;
//       const amount = item.amount || 0;
//       const normalizedMode = normalizeCurrency(item.payment_mode);
      
//       if (!yearlySummary[year]) {
//         yearlySummary[year] = {
//           usdRevenue: 0,
//           etbRevenue: 0,
//           totalRevenue: 0,
//           transactionCount: 0
//         };
//       }
      
//       if (normalizedMode === "usd") {
//         yearlySummary[year].usdRevenue += amount;
//       } else if (normalizedMode === "birr") {
//         yearlySummary[year].etbRevenue += amount;
//       }
      
//       yearlySummary[year].totalRevenue += amount;
//       yearlySummary[year].transactionCount++;
//     });
    
//     // Sort years in descending order
//     const sortedYears = Object.keys(yearlySummary).sort((a, b) => b - a);
//     const sortedSummary = {};
//     sortedYears.forEach(year => {
//       sortedSummary[year] = yearlySummary[year];
//     });
    
//     return sortedSummary;
//   };

//   // Prepare yearly data for a specific park
//   const getYearlyDataForPark = (parkName) => {
//     const parkYearlyData = {};
    
//     filteredData.forEach(item => {
//       if (item.park_name === parkName) {
//         const year = item.year;
//         const amount = item.amount || 0;
//         const normalizedMode = normalizeCurrency(item.payment_mode);
        
//         if (!parkYearlyData[year]) {
//           parkYearlyData[year] = {
//             usdRevenue: 0,
//             etbRevenue: 0,
//             totalRevenue: 0
//           };
//         }
        
//         if (normalizedMode === "usd") {
//           parkYearlyData[year].usdRevenue += amount;
//         } else if (normalizedMode === "birr") {
//           parkYearlyData[year].etbRevenue += amount;
//         }
        
//         parkYearlyData[year].totalRevenue += amount;
//       }
//     });
    
//     // Sort years
//     const sortedYears = Object.keys(parkYearlyData).sort((a, b) => a - b);
//     const sortedData = {};
//     sortedYears.forEach(year => {
//       sortedData[year] = parkYearlyData[year];
//     });
    
//     return sortedData;
//   };

//   // Filter Data with Year Range and Month Range
//   const applyFilters = useCallback(() => {
//     let filtered = [...revenueData];
    
//     if (searchTerm) {
//       filtered = filtered.filter(item =>
//         item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.transaction_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.park_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.invoice_number?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }
    
//     if (selectedPark !== "all") {
//       filtered = filtered.filter(item => item.park_name === selectedPark);
//     }
    
//     if (selectedStatus !== "all") {
//       filtered = filtered.filter(item => item.payment_status === selectedStatus);
//     }
    
//     if (selectedCurrency !== "all") {
//       filtered = filtered.filter(item => 
//         normalizeCurrency(item.payment_mode) === selectedCurrency
//       );
//     }
    
//     // YEAR RANGE FILTER
//     if (startYear !== "all" || endYear !== "all") {
//       filtered = filtered.filter(item => {
//         const itemYear = parseInt(item.year);
        
//         let startYearNum = startYear !== "all" ? parseInt(startYear) : -Infinity;
//         let endYearNum = endYear !== "all" ? parseInt(endYear) : Infinity;
        
//         return itemYear >= startYearNum && itemYear <= endYearNum;
//       });
//     }
    
//     // MONTH RANGE FILTER
//     if (startMonth !== "all" || endMonth !== "all") {
//       filtered = filtered.filter(item => {
//         const itemMonth = parseInt(item.month);
        
//         let startMonthNum = startMonth !== "all" ? parseInt(startMonth) : 1;
//         let endMonthNum = endMonth !== "all" ? parseInt(endMonth) : 12;
        
//         return itemMonth >= startMonthNum && itemMonth <= endMonthNum;
//       });
//     }
    
//     // Keep single year filter for backward compatibility
//     if (selectedYear !== "all" && startYear === "all" && endYear === "all") {
//       filtered = filtered.filter(item => item.year === selectedYear);
//     }
    
//     // Keep single month filter for backward compatibility
//     if (selectedMonth !== "all" && startMonth === "all" && endMonth === "all") {
//       filtered = filtered.filter(item => item.month === selectedMonth);
//     }
    
//     setFilteredData(filtered);
//     setPage(0);
//   }, [revenueData, searchTerm, selectedPark, selectedStatus, selectedCurrency, selectedYear, selectedMonth, startYear, endYear, startMonth, endMonth]);

//   useEffect(() => {
//     applyFilters();
//   }, [applyFilters]);

//   // Handle View Details
//   const handleViewDetails = (row) => {
//     setSelectedRevenue(row);
//     setOpenDetailsDialog(true);
//   };

//   // Reset Filters
//   const resetFilters = () => {
//     setSearchTerm("");
//     setSelectedPark("all");
//     setSelectedStatus("all");
//     setSelectedCurrency("all");
//     setSelectedYear("all");
//     setSelectedMonth("all");
//     setStartYear("all");
//     setEndYear("all");
//     setStartMonth("all");
//     setEndMonth("all");
//   };

//   // Export to CSV
//   const handleExportCSV = () => {
//     if (filteredData.length === 0) {
//       alert("No data to export");
//       return;
//     }
    
//     const headers = ['Transaction ID', 'Company Name', 'Park Name', 'Payment Mode', 'Amount', 'Transaction Date', 'Revenue Type', 'Payment Status', 'Invoice Number', 'Year', 'Month'];
//     const csvData = filteredData.map(item => [
//       item.transaction_id,
//       item.company_name,
//       item.park_name,
//       item.payment_mode,
//       item.formattedAmount,
//       item.transaction_date_formatted,
//       item.revenue_type,
//       item.payment_status,
//       item.invoice_number,
//       item.year,
//       item.month
//     ]);
    
//     const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `revenue_report_${format(new Date(), 'yyyyMMdd')}.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   // Handle page change
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Get current page data
//   const getCurrentPageData = () => {
//     const startIndex = page * rowsPerPage;
//     const endIndex = startIndex + rowsPerPage;
//     return filteredData.slice(startIndex, endIndex);
//   };

//   // Handle chart type change
//   const handleChartTypeChange = (event, newChartType) => {
//     if (newChartType !== null) {
//       setChartType(newChartType);
//     }
//   };

//   // Yearly Line Chart Component
//   const YearlyLineChart = ({ title, yearlyData, currencySymbol, currencyType }) => {
//     const years = Object.keys(yearlyData).sort((a, b) => a - b);
    
//     if (years.length === 0) {
//       return (
//         <Box sx={{ p: 3, textAlign: 'center' }}>
//           <Typography variant="body2" color="textSecondary">
//             No yearly data available
//           </Typography>
//         </Box>
//       );
//     }
    
//     const maxValue = Math.max(
//       ...Object.values(yearlyData).map(d => 
//         currencyType === 'usd' ? (d.usdRevenue || 0) : 
//         currencyType === 'etb' ? (d.etbRevenue || 0) : 
//         (d.totalRevenue || 0)
//       ),
//       0
//     );
    
//     const chartHeight = 350;
//     const chartWidth = Math.max(600, years.length * 100);
//     const padding = { top: 30, right: 40, bottom: 60, left: 70 };
    
//     return (
//       <Box sx={{ p: 2, overflowX: 'auto' }}>
//         <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
//           {title}
//         </Typography>
        
//         <svg width={chartWidth} height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
//           {/* Grid lines */}
//           {[0, 25, 50, 75, 100].map((percent) => {
//             const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
//             const value = (maxValue * percent) / 100;
//             return (
//               <g key={percent}>
//                 <line
//                   x1={padding.left}
//                   y1={y}
//                   x2={chartWidth - padding.right}
//                   y2={y}
//                   stroke="#e0e0e0"
//                   strokeWidth="1"
//                   strokeDasharray="4"
//                 />
//                 <text
//                   x={padding.left - 8}
//                   y={y}
//                   textAnchor="end"
//                   fontSize="10"
//                   fill="#666"
//                 >
//                   {currencySymbol}{formatNumber(value)}
//                 </text>
//               </g>
//             );
//           })}
          
//           {/* Line */}
//           <polyline
//             points={years.map((year, index) => {
//               const x = padding.left + (index / (years.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
//               let revenueValue = 0;
//               if (currencyType === 'usd') {
//                 revenueValue = yearlyData[year].usdRevenue || 0;
//               } else if (currencyType === 'etb') {
//                 revenueValue = yearlyData[year].etbRevenue || 0;
//               } else {
//                 revenueValue = yearlyData[year].totalRevenue || 0;
//               }
//               const y = chartHeight - padding.bottom - (revenueValue / maxValue) * (chartHeight - padding.top - padding.bottom);
//               return `${x},${y}`;
//             }).join(' ')}
//             fill="none"
//             stroke={currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0')}
//             strokeWidth="2.5"
//           />
          
//           {/* Points and labels */}
//           {years.map((year, index) => {
//             const x = padding.left + (index / (years.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
//             let revenueValue = 0;
//             if (currencyType === 'usd') {
//               revenueValue = yearlyData[year].usdRevenue || 0;
//             } else if (currencyType === 'etb') {
//               revenueValue = yearlyData[year].etbRevenue || 0;
//             } else {
//               revenueValue = yearlyData[year].totalRevenue || 0;
//             }
//             const y = chartHeight - padding.bottom - (revenueValue / maxValue) * (chartHeight - padding.top - padding.bottom);
            
//             return (
//               <g key={year}>
//                 <Tooltip
//                   title={
//                     <Box sx={{ p: 1 }}>
//                       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>Year: {year}</Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         {currencyType === 'usd' ? `USD Revenue: ${currencySymbol}${formatNumber(revenueValue)}` :
//                          currencyType === 'etb' ? `ETB Revenue: ${currencySymbol}${formatNumber(revenueValue)}` :
//                          `Total Revenue: ${currencySymbol}${formatNumber(revenueValue)}`}
//                       </Typography>
//                       {currencyType === 'both' && (
//                         <>
//                           <Typography variant="body2" sx={{ color: '#fff' }}>
//                             USD: ${formatNumber(yearlyData[year].usdRevenue || 0)}
//                           </Typography>
//                           <Typography variant="body2" sx={{ color: '#fff' }}>
//                             ETB: {formatNumber(yearlyData[year].etbRevenue || 0)} ETB
//                           </Typography>
//                         </>
//                       )}
//                     </Box>
//                   }
//                   arrow
//                   placement="top"
//                 >
//                   <circle
//                     cx={x}
//                     cy={y}
//                     r="6"
//                     fill={currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0')}
//                     stroke="white"
//                     strokeWidth="2"
//                     style={{ cursor: 'pointer' }}
//                   />
//                 </Tooltip>
//                 <text
//                   x={x}
//                   y={chartHeight - padding.bottom + 20}
//                   textAnchor="middle"
//                   fontSize="11"
//                   fontWeight="bold"
//                 >
//                   {year}
//                 </text>
//                 <text
//                   x={x}
//                   y={y - 8}
//                   textAnchor="middle"
//                   fontSize="9"
//                   fill="#666"
//                 >
//                   {currencySymbol}{formatNumber(revenueValue)}
//                 </text>
//               </g>
//             );
//           })}
          
//           {/* Axes */}
//           <line
//             x1={padding.left}
//             y1={padding.top}
//             x2={padding.left}
//             y2={chartHeight - padding.bottom}
//             stroke="#999"
//             strokeWidth="1.5"
//           />
//           <line
//             x1={padding.left}
//             y1={chartHeight - padding.bottom}
//             x2={chartWidth - padding.right}
//             y2={chartHeight - padding.bottom}
//             stroke="#999"
//             strokeWidth="1.5"
//           />
          
//           {/* Y-axis label */}
//           <text
//             x={20}
//             y={chartHeight / 2}
//             textAnchor="middle"
//             fontSize="11"
//             fill="#666"
//             transform={`rotate(-90, 20, ${chartHeight / 2})`}
//           >
//             Revenue Amount
//           </text>
          
//           {/* X-axis label */}
//           <text
//             x={chartWidth / 2}
//             y={chartHeight - 10}
//             textAnchor="middle"
//             fontSize="11"
//             fill="#666"
//           >
//             Year
//           </text>
//         </svg>
        
//         <Box sx={{ 
//           width: '100%', 
//           bgcolor: '#f5f5f5', 
//           mt: 3,
//           display: 'flex', 
//           flexDirection: 'column', 
//           alignItems: 'center', 
//           p: 2,
//           borderRadius: 1
//         }}>
//           <Typography variant="body2" color="textSecondary">
//             Years: {years.join(' → ')}
//           </Typography>
//         </Box>
//       </Box>
//     );
//   };

//   // Yearly Bar Chart Component
//   const YearlyBarChart = ({ title, yearlyData, currencySymbol, currencyType }) => {
//     const years = Object.keys(yearlyData).sort((a, b) => a - b);
    
//     if (years.length === 0) {
//       return (
//         <Box sx={{ p: 3, textAlign: 'center' }}>
//           <Typography variant="body2" color="textSecondary">
//             No yearly data available
//           </Typography>
//         </Box>
//       );
//     }
    
//     const maxValue = Math.max(
//       ...Object.values(yearlyData).map(d => 
//         currencyType === 'usd' ? (d.usdRevenue || 0) : 
//         currencyType === 'etb' ? (d.etbRevenue || 0) : 
//         (d.totalRevenue || 0)
//       ),
//       0
//     );
    
//     const barColor = currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0');
    
//     return (
//       <Box sx={{ p: 2, overflowX: 'auto' }}>
//         <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
//           {title}
//         </Typography>
        
//         <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 3, minHeight: 350, justifyContent: 'center', flexWrap: 'wrap' }}>
//           {years.map((year) => {
//             let revenueValue = 0;
//             if (currencyType === 'usd') {
//               revenueValue = yearlyData[year].usdRevenue || 0;
//             } else if (currencyType === 'etb') {
//               revenueValue = yearlyData[year].etbRevenue || 0;
//             } else {
//               revenueValue = yearlyData[year].totalRevenue || 0;
//             }
            
//             const height = maxValue > 0 ? (revenueValue / maxValue) * 220 : 0;
            
//             return (
//               <Tooltip
//                 key={year}
//                 title={
//                   <Box sx={{ p: 1 }}>
//                     <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>Year: {year}</Typography>
//                     <Typography variant="body2" sx={{ color: '#fff' }}>
//                       {currencyType === 'usd' ? `USD Revenue: ${currencySymbol}${formatNumber(revenueValue)}` :
//                        currencyType === 'etb' ? `ETB Revenue: ${currencySymbol}${formatNumber(revenueValue)}` :
//                        `Total Revenue: ${currencySymbol}${formatNumber(revenueValue)}`}
//                     </Typography>
//                     {currencyType === 'both' && (
//                       <>
//                         <Typography variant="body2" sx={{ color: '#fff' }}>
//                           USD: ${formatNumber(yearlyData[year].usdRevenue || 0)}
//                         </Typography>
//                         <Typography variant="body2" sx={{ color: '#fff' }}>
//                           ETB: {formatNumber(yearlyData[year].etbRevenue || 0)} ETB
//                         </Typography>
//                       </>
//                     )}
//                   </Box>
//                 }
//                 arrow
//                 placement="top"
//               >
//                 <Box sx={{ textAlign: 'center', minWidth: 80, cursor: 'pointer' }}>
//                   <Box sx={{ 
//                     height: height, 
//                     width: '60px',
//                     bgcolor: barColor,
//                     borderRadius: '4px 4px 0 0',
//                     margin: '0 auto',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       opacity: 0.8,
//                       transform: 'translateY(-5px)',
//                       boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
//                     }
//                   }} />
//                   <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
//                     {year}
//                   </Typography>
//                   <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
//                     {currencySymbol}{formatNumber(revenueValue)}
//                   </Typography>
//                 </Box>
//               </Tooltip>
//             );
//           })}
//         </Box>
        
//         <Box sx={{ 
//           width: '100%', 
//           bgcolor: '#f5f5f5', 
//           mt: 3,
//           display: 'flex', 
//           flexDirection: 'column', 
//           alignItems: 'center', 
//           p: 2,
//           borderRadius: 1
//         }}>
//           <Typography variant="body2" color="textSecondary">
//             Total Years: {years.length} | Range: {years[0]} - {years[years.length - 1]}
//           </Typography>
//         </Box>
//       </Box>
//     );
//   };

//   // Combined Line Chart Component (USD and ETB together)
//   const CombinedLineChart = ({ data }) => {
//     const parks = Object.keys(data);
//     const maxUsdValue = Math.max(...Object.values(data).map(d => d.usdRevenue), 0);
//     const maxEtbValue = Math.max(...Object.values(data).map(d => d.etbRevenue), 0);
//     const maxValue = Math.max(maxUsdValue, maxEtbValue);
    
//     if (parks.length === 0) {
//       return (
//         <Box sx={{ p: 3, textAlign: 'center' }}>
//           <Typography variant="body2" color="textSecondary">
//             No data available
//           </Typography>
//         </Box>
//       );
//     }
    
//     const chartHeight = 350;
//     const chartWidth = Math.max(800, parks.length * 80);
//     const padding = { top: 30, right: 40, bottom: 80, left: 70 };
    
//     return (
//       <Box sx={{ p: 2, overflowX: 'auto' }}>
//         <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
//           Revenue Trend Comparison by Park (USD vs ETB)
//         </Typography>
        
//         <svg width={chartWidth} height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
//           {/* Grid lines */}
//           {[0, 25, 50, 75, 100].map((percent) => {
//             const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
//             const value = (maxValue * percent) / 100;
//             return (
//               <g key={percent}>
//                 <line
//                   x1={padding.left}
//                   y1={y}
//                   x2={chartWidth - padding.right}
//                   y2={y}
//                   stroke="#e0e0e0"
//                   strokeWidth="1"
//                   strokeDasharray="4"
//                 />
//                 <text
//                   x={padding.left - 8}
//                   y={y}
//                   textAnchor="end"
//                   fontSize="10"
//                   fill="#666"
//                 >
//                   {formatNumber(value)}
//                 </text>
//               </g>
//             );
//           })}
          
//           {/* USD Line */}
//           <polyline
//             points={parks.map((park, index) => {
//               const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
//               const y = chartHeight - padding.bottom - (data[park].usdRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
//               return `${x},${y}`;
//             }).join(' ')}
//             fill="none"
//             stroke="#1976d2"
//             strokeWidth="2.5"
//             strokeDasharray="0"
//           />
          
//           {/* ETB Line */}
//           <polyline
//             points={parks.map((park, index) => {
//               const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
//               const y = chartHeight - padding.bottom - (data[park].etbRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
//               return `${x},${y}`;
//             }).join(' ')}
//             fill="none"
//             stroke="#2e7d32"
//             strokeWidth="2.5"
//             strokeDasharray="0"
//           />
          
//           {/* Points and labels for both lines */}
//           {parks.map((park, index) => {
//             const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
//             const yUsd = chartHeight - padding.bottom - (data[park].usdRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
//             const yEtb = chartHeight - padding.bottom - (data[park].etbRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
//             const totalAmount = data[park].usdRevenue + data[park].etbRevenue;
//             const usdPercentage = totalAmount > 0 ? (data[park].usdRevenue / totalAmount) * 100 : 0;
//             const etbPercentage = totalAmount > 0 ? (data[park].etbRevenue / totalAmount) * 100 : 0;
            
//             return (
//               <g key={park}>
//                 {/* USD Point */}
//                 <Tooltip
//                   title={
//                     <Box sx={{ p: 1 }}>
//                       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         USD: ${formatNumber(data[park].usdRevenue)} ({usdPercentage.toFixed(1)}%)
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         ETB: {formatNumber(data[park].etbRevenue)} ETB ({etbPercentage.toFixed(1)}%)
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         Total: ${formatNumber(data[park].usdRevenue)} + {formatNumber(data[park].etbRevenue)} ETB
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         Transactions: {data[park].transactionCount}
//                       </Typography>
//                     </Box>
//                   }
//                   arrow
//                   placement="top"
//                 >
//                   <circle
//                     cx={x}
//                     cy={yUsd}
//                     r="5"
//                     fill="#1976d2"
//                     stroke="white"
//                     strokeWidth="2"
//                     style={{ cursor: 'pointer' }}
//                   />
//                 </Tooltip>
                
//                 {/* ETB Point */}
//                 <Tooltip
//                   title={
//                     <Box sx={{ p: 1 }}>
//                       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         USD: ${formatNumber(data[park].usdRevenue)} ({usdPercentage.toFixed(1)}%)
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         ETB: {formatNumber(data[park].etbRevenue)} ETB ({etbPercentage.toFixed(1)}%)
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         Total: ${formatNumber(data[park].usdRevenue)} + {formatNumber(data[park].etbRevenue)} ETB
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         Transactions: {data[park].transactionCount}
//                       </Typography>
//                     </Box>
//                   }
//                   arrow
//                   placement="top"
//                 >
//                   <circle
//                     cx={x}
//                     cy={yEtb}
//                     r="5"
//                     fill="#2e7d32"
//                     stroke="white"
//                     strokeWidth="2"
//                     style={{ cursor: 'pointer' }}
//                   />
//                 </Tooltip>
                
//                 {/* Park Name Label */}
//                 <text
//                   x={x}
//                   y={chartHeight - padding.bottom + 20}
//                   textAnchor="middle"
//                   fontSize="10"
//                   transform={`rotate(-45, ${x}, ${chartHeight - padding.bottom + 20})`}
//                 >
//                   {park.length > 15 ? park.substring(0, 12) + '...' : park}
//                 </text>
//               </g>
//             );
//           })}
          
//           {/* Axes */}
//           <line
//             x1={padding.left}
//             y1={padding.top}
//             x2={padding.left}
//             y2={chartHeight - padding.bottom}
//             stroke="#999"
//             strokeWidth="1.5"
//           />
//           <line
//             x1={padding.left}
//             y1={chartHeight - padding.bottom}
//             x2={chartWidth - padding.right}
//             y2={chartHeight - padding.bottom}
//             stroke="#999"
//             strokeWidth="1.5"
//           />
          
//           {/* Y-axis label */}
//           <text
//             x={20}
//             y={chartHeight / 2}
//             textAnchor="middle"
//             fontSize="11"
//             fill="#666"
//             transform={`rotate(-90, 20, ${chartHeight / 2})`}
//           >
//             Revenue Amount
//           </text>
//         </svg>
        
//         {/* Legend */}
//         <Box sx={{ 
//           mt: 4, 
//           display: 'flex', 
//           justifyContent: 'center', 
//           gap: 4,
//           borderTop: '1px solid #e0e0e0',
//           pt: 2
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Box sx={{ width: 30, height: 3, bgcolor: '#1976d2' }} />
//             <Box sx={{ width: 10, height: 10, bgcolor: '#1976d2', borderRadius: '50%' }} />
//             <Typography variant="caption">USD Revenue Trend</Typography>
//           </Box>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Box sx={{ width: 30, height: 3, bgcolor: '#2e7d32' }} />
//             <Box sx={{ width: 10, height: 10, bgcolor: '#2e7d32', borderRadius: '50%' }} />
//             <Typography variant="caption">ETB Revenue Trend</Typography>
//           </Box>
//         </Box>
        
//         <Box sx={{ 
//           width: '100%', 
//           bgcolor: '#f5f5f5', 
//           mt: 2,
//           display: 'flex', 
//           flexDirection: 'column', 
//           alignItems: 'center', 
//           p: 2,
//           borderRadius: 1
//         }}>
//           <Typography variant="body2" color="textSecondary">
//             Number of Parks: {parks.length}
//           </Typography>
//           <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
//             Total USD: ${formatNumber(totalUSD)} | Total ETB: {formatNumber(totalETB)} ETB
//           </Typography>
//         </Box>
//       </Box>
//     );
//   };

//   // Combined Bar Chart Component (USD and ETB together)
//   const CombinedBarChart = ({ data }) => {
//     const maxUsdValue = Math.max(...Object.values(data).map(d => d.usdRevenue), 0);
//     const maxEtbValue = Math.max(...Object.values(data).map(d => d.etbRevenue), 0);
//     const maxValue = Math.max(maxUsdValue, maxEtbValue);
//     const parks = Object.keys(data);
    
//     if (parks.length === 0) {
//       return (
//         <Box sx={{ p: 3, textAlign: 'center' }}>
//           <Typography variant="body2" color="textSecondary">
//             No data available
//           </Typography>
//         </Box>
//       );
//     }
    
//     return (
//       <Box sx={{ p: 2, overflowX: 'auto' }}>
//         <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
//           Revenue Comparison by Park (USD vs ETB)
//         </Typography>
        
//         <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 3, minHeight: 350, justifyContent: 'center', flexWrap: 'wrap' }}>
//           {parks.map((park) => {
//             const usdHeight = maxValue > 0 ? (data[park].usdRevenue / maxValue) * 220 : 0;
//             const etbHeight = maxValue > 0 ? (data[park].etbRevenue / maxValue) * 220 : 0;
//             const totalAmount = data[park].usdRevenue + data[park].etbRevenue;
//             const usdPercentage = totalAmount > 0 ? (data[park].usdRevenue / totalAmount) * 100 : 0;
//             const etbPercentage = totalAmount > 0 ? (data[park].etbRevenue / totalAmount) * 100 : 0;
            
//             return (
//               <Box key={park} sx={{ textAlign: 'center', minWidth: 120, cursor: 'pointer' }}>
//                 <Tooltip
//                   title={
//                     <Box sx={{ p: 1 }}>
//                       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         USD: ${formatNumber(data[park].usdRevenue)} ({usdPercentage.toFixed(1)}%)
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         ETB: {formatNumber(data[park].etbRevenue)} ETB ({etbPercentage.toFixed(1)}%)
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         Total: ${formatNumber(data[park].usdRevenue)} + {formatNumber(data[park].etbRevenue)} ETB
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         Transactions: {data[park].transactionCount}
//                       </Typography>
//                     </Box>
//                   }
//                   arrow
//                   placement="top"
//                 >
//                   <Box>
//                     <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.5, justifyContent: 'center' }}>
//                       {/* USD Bar */}
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Box sx={{ 
//                           height: usdHeight, 
//                           width: '40px',
//                           bgcolor: '#1976d2',
//                           borderRadius: '4px 4px 0 0',
//                           margin: '0 auto',
//                           position: 'relative',
//                           transition: 'all 0.3s ease',
//                           '&:hover': {
//                             opacity: 0.8,
//                             transform: 'translateY(-5px)',
//                             boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
//                           }
//                         }} />
//                         <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontSize: '10px', color: '#1976d2' }}>
//                           USD
//                         </Typography>
//                       </Box>
                      
//                       {/* ETB Bar */}
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Box sx={{ 
//                           height: etbHeight, 
//                           width: '40px',
//                           bgcolor: '#2e7d32',
//                           borderRadius: '4px 4px 0 0',
//                           margin: '0 auto',
//                           position: 'relative',
//                           transition: 'all 0.3s ease',
//                           '&:hover': {
//                             opacity: 0.8,
//                             transform: 'translateY(-5px)',
//                             boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
//                           }
//                         }} />
//                         <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontSize: '10px', color: '#2e7d32' }}>
//                           ETB
//                         </Typography>
//                       </Box>
//                     </Box>
                    
//                     <Typography variant="caption" sx={{ mt: 1, display: 'block', fontWeight: 'bold' }}>
//                       {park.length > 15 ? park.substring(0, 12) + '...' : park}
//                     </Typography>
//                     <Typography variant="caption" color="textSecondary" sx={{ display: 'block', fontSize: '9px' }}>
//                       ${formatNumber(data[park].usdRevenue)} | {formatNumber(data[park].etbRevenue)} ETB
//                     </Typography>
//                   </Box>
//                 </Tooltip>
//               </Box>
//             );
//           })}
//         </Box>
        
//         {/* Legend */}
//         <Box sx={{ 
//           mt: 4, 
//           display: 'flex', 
//           justifyContent: 'center', 
//           gap: 4,
//           borderTop: '1px solid #e0e0e0',
//           pt: 2
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Box sx={{ width: 20, height: 20, bgcolor: '#1976d2', borderRadius: 1 }} />
//             <Typography variant="caption">USD Revenue</Typography>
//           </Box>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Box sx={{ width: 20, height: 20, bgcolor: '#2e7d32', borderRadius: 1 }} />
//             <Typography variant="caption">ETB Revenue</Typography>
//           </Box>
//         </Box>
        
//         <Box sx={{ 
//           width: '100%', 
//           bgcolor: '#f5f5f5', 
//           mt: 2,
//           display: 'flex', 
//           flexDirection: 'column', 
//           alignItems: 'center', 
//           p: 2,
//           borderRadius: 1
//         }}>
//           <Typography variant="body2" color="textSecondary">
//             Number of Parks: {parks.length}
//           </Typography>
//           <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
//             Total USD: ${formatNumber(totalUSD)} | Total ETB: {formatNumber(totalETB)} ETB
//           </Typography>
//         </Box>
//       </Box>
//     );
//   };

//   // Standard Chart Component for single currency
//   const SingleCurrencyChart = ({ title, data, totalAmount, currencySymbol, chartType }) => {
//     const maxValue = Math.max(...Object.values(data).map(d => d.totalRevenue), 0);
//     const parks = Object.keys(data);
    
//     if (Object.keys(data).length === 0) {
//       return (
//         <Box sx={{ p: 3, textAlign: 'center' }}>
//           <Typography variant="body2" color="textSecondary">
//             No data available for {title}
//           </Typography>
//         </Box>
//       );
//     }

//     // Line Chart Component for single currency
//     const LineChart = () => {
//       const chartHeight = 300;
//       const chartWidth = Math.max(600, parks.length * 70);
//       const padding = { top: 20, right: 30, bottom: 60, left: 60 };
      
//       return (
//         <svg width="100%" height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
//           {/* Grid lines */}
//           {[0, 25, 50, 75, 100].map((percent) => {
//             const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
//             const value = (maxValue * percent) / 100;
//             return (
//               <g key={percent}>
//                 <line
//                   x1={padding.left}
//                   y1={y}
//                   x2={chartWidth - padding.right}
//                   y2={y}
//                   stroke="#e0e0e0"
//                   strokeWidth="1"
//                   strokeDasharray="4"
//                 />
//                 <text
//                   x={padding.left - 5}
//                   y={y}
//                   textAnchor="end"
//                   fontSize="10"
//                   fill="#666"
//                 >
//                   {currencySymbol}{formatNumber(value)}
//                 </text>
//               </g>
//             );
//           })}
          
//           {/* Line */}
//           <polyline
//             points={parks.map((park, index) => {
//               const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
//               const y = chartHeight - padding.bottom - (data[park].totalRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
//               return `${x},${y}`;
//             }).join(' ')}
//             fill="none"
//             stroke={title.includes('USD') ? '#1976d2' : '#2e7d32'}
//             strokeWidth="2"
//           />
          
//           {/* Points and labels */}
//           {parks.map((park, index) => {
//             const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
//             const y = chartHeight - padding.bottom - (data[park].totalRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
//             const percentage = totalAmount > 0 ? (data[park].totalRevenue / totalAmount) * 100 : 0;
            
//             return (
//               <g key={park}>
//                 <Tooltip
//                   title={
//                     <Box sx={{ p: 1 }}>
//                       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         Amount: {currencySymbol}{formatNumber(data[park].totalRevenue)}
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         Percentage: {percentage.toFixed(2)}%
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         Transactions: {data[park].transactionCount}
//                       </Typography>
//                     </Box>
//                   }
//                   arrow
//                   placement="top"
//                 >
//                   <circle
//                     cx={x}
//                     cy={y}
//                     r="4"
//                     fill={title.includes('USD') ? '#1976d2' : '#2e7d32'}
//                     stroke="white"
//                     strokeWidth="2"
//                     style={{ cursor: 'pointer' }}
//                   />
//                 </Tooltip>
//                 <text
//                   x={x}
//                   y={chartHeight - padding.bottom + 15}
//                   textAnchor="middle"
//                   fontSize="10"
//                   transform={`rotate(-45, ${x}, ${chartHeight - padding.bottom + 15})`}
//                 >
//                   {park.length > 12 ? park.substring(0, 10) + '...' : park}
//                 </text>
//                 <text
//                   x={x}
//                   y={y - 8}
//                   textAnchor="middle"
//                   fontSize="9"
//                   fill="#666"
//                 >
//                   {currencySymbol}{formatNumber(data[park].totalRevenue)}
//                 </text>
//               </g>
//             );
//           })}
          
//           {/* Axes */}
//           <line
//             x1={padding.left}
//             y1={padding.top}
//             x2={padding.left}
//             y2={chartHeight - padding.bottom}
//             stroke="#999"
//             strokeWidth="1"
//           />
//           <line
//             x1={padding.left}
//             y1={chartHeight - padding.bottom}
//             x2={chartWidth - padding.right}
//             y2={chartHeight - padding.bottom}
//             stroke="#999"
//             strokeWidth="1"
//           />
//         </svg>
//       );
//     };

//     // Bar Chart Component
//     const BarChart = () => {
//       return (
//         <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 300, justifyContent: 'center', flexWrap: 'wrap' }}>
//           {Object.entries(data).map(([park, parkData]) => {
//             const height = maxValue > 0 ? (parkData.totalRevenue / maxValue) * 200 : 0;
//             const percentage = totalAmount > 0 ? (parkData.totalRevenue / totalAmount) * 100 : 0;
//             return (
//               <Tooltip
//                 key={park}
//                 title={
//                   <Box sx={{ p: 1 }}>
//                     <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
//                     <Typography variant="body2" sx={{ color: '#fff' }}>
//                       Amount: {currencySymbol}{formatNumber(parkData.totalRevenue)}
//                     </Typography>
//                     <Typography variant="body2" sx={{ color: '#fff' }}>
//                       Percentage: {percentage.toFixed(2)}%
//                     </Typography>
//                     <Typography variant="body2" sx={{ color: '#fff' }}>
//                       Transactions: {parkData.transactionCount}
//                     </Typography>
//                   </Box>
//                 }
//                 arrow
//                 placement="top"
//               >
//                 <Box sx={{ textAlign: 'center', flex: 1, minWidth: 80, cursor: 'pointer' }}>
//                   <Box sx={{ 
//                     height: height, 
//                     width: '60px',
//                     bgcolor: title.includes('USD') ? '#1976d2' : '#2e7d32',
//                     borderRadius: '4px 4px 0 0',
//                     margin: '0 auto',
//                     position: 'relative',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       opacity: 0.8,
//                       transform: 'translateY(-5px)',
//                       boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
//                     }
//                   }} />
//                   <Typography variant="caption" sx={{ mt: 1, display: 'block', fontWeight: 'bold' }}>
//                     {park.length > 12 ? park.substring(0, 10) + '...' : park}
//                   </Typography>
//                   <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
//                     {currencySymbol}{formatNumber(parkData.totalRevenue)}
//                   </Typography>
//                 </Box>
//               </Tooltip>
//             );
//           })}
//         </Box>
//       );
//     };

//     // Pie Chart Component
//     const PieChart = () => {
//       let cumulativePercentage = 0;
//       const colors = ['#2e7d32', '#1976d2', '#ff9800', '#9c27b0', '#f44336', '#00bcd4', '#795548', '#607d8b'];
      
//       return (
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
//           <Box sx={{ position: 'relative', width: 250, height: 250 }}>
//             <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%' }}>
//               {Object.entries(data).map(([park, parkData], index) => {
//                 const percentage = (parkData.totalRevenue / totalAmount) * 100;
//                 const startAngle = cumulativePercentage * 3.6;
//                 const endAngle = (cumulativePercentage + percentage) * 3.6;
//                 cumulativePercentage += percentage;
                
//                 const startRad = (startAngle - 90) * Math.PI / 180;
//                 const endRad = (endAngle - 90) * Math.PI / 180;
                
//                 const x1 = 50 + 40 * Math.cos(startRad);
//                 const y1 = 50 + 40 * Math.sin(startRad);
//                 const x2 = 50 + 40 * Math.cos(endRad);
//                 const y2 = 50 + 40 * Math.sin(endRad);
                
//                 const largeArc = percentage > 50 ? 1 : 0;
                
//                 return (
//                   <Tooltip
//                     key={park}
//                     title={
//                       <Box sx={{ p: 1 }}>
//                         <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
//                         <Typography variant="body2" sx={{ color: '#fff' }}>
//                           Amount: {currencySymbol}{formatNumber(parkData.totalRevenue)}
//                         </Typography>
//                         <Typography variant="body2" sx={{ color: '#fff' }}>
//                           Percentage: {percentage.toFixed(2)}%
//                         </Typography>
//                         <Typography variant="body2" sx={{ color: '#fff' }}>
//                           Transactions: {parkData.transactionCount}
//                         </Typography>
//                       </Box>
//                     }
//                     arrow
//                     placement="top"
//                   >
//                     <path
//                       d={`M 50 50 L ${x1} ${y1} A 40 40 0 ${largeArc} 1 ${x2} ${y2} Z`}
//                       fill={colors[index % colors.length]}
//                       stroke="white"
//                       strokeWidth="1"
//                       style={{ cursor: 'pointer' }}
//                     />
//                   </Tooltip>
//                 );
//               })}
//               <circle cx="50" cy="50" r="25" fill="white" />
//             </svg>
//           </Box>
//           <Box sx={{ minWidth: 200 }}>
//             {Object.entries(data).map(([park, parkData], index) => {
//               const percentage = (parkData.totalRevenue / totalAmount) * 100;
//               return (
//                 <Box key={park} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                   <Box sx={{ width: 12, height: 12, bgcolor: colors[index % colors.length], borderRadius: 1 }} />
//                   <Typography variant="caption" sx={{ flex: 1 }}>
//                     {park.length > 20 ? park.substring(0, 18) + '...' : park} ({percentage.toFixed(1)}%)
//                   </Typography>
//                   <Typography variant="caption" fontWeight="bold">
//                     {currencySymbol}{formatNumber(parkData.totalRevenue)}
//                   </Typography>
//                 </Box>
//               );
//             })}
//           </Box>
//         </Box>
//       );
//     };

//     return (
//       <Box sx={{ p: 2 }}>
//         <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 2 }}>
//           {title} - Total: {currencySymbol}{formatNumber(totalAmount)}
//         </Typography>
        
//         {chartType === 'line' && <LineChart />}
//         {chartType === 'bar' && <BarChart />}
//         {chartType === 'pie' && <PieChart />}
        
//         <Box sx={{ 
//           width: '100%', 
//           bgcolor: '#f5f5f5', 
//           mt: 2,
//           display: 'flex', 
//           flexDirection: 'column', 
//           alignItems: 'center', 
//           p: 2,
//           borderRadius: 1
//         }}>
//           <Typography variant="body2" color="textSecondary">
//             Number of Parks: {Object.keys(data).length}
//           </Typography>
//           <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
//             Total Revenue: {currencySymbol}{formatNumber(totalAmount)}
//           </Typography>
//         </Box>
//       </Box>
//     );
//   };

//   // Yearly Chart Dashboard Component
//   const YearlyChartDashboard = () => {
//     const [yearlyChartType, setYearlyChartType] = useState('line');
//     const [yearlyCurrencyView, setYearlyCurrencyView] = useState('both');
    
//     const yearlySummaryData = getYearlySummaryData();
//     const parksListForYearly = [...new Set(filteredData.map(item => item.park_name).filter(Boolean))];
    
//     const getYearlyDataForDisplay = () => {
//       if (selectedParkForYearly !== "all") {
//         return getYearlyDataForPark(selectedParkForYearly);
//       }
//       return yearlySummaryData;
//     };
    
//     const displayData = getYearlyDataForDisplay();
    
//     const getChartTitle = () => {
//       let title = "Yearly Revenue Trend";
//       if (selectedParkForYearly !== "all") {
//         title += ` - ${selectedParkForYearly}`;
//       }
//       if (yearlyCurrencyView === 'usd') {
//         title += " (USD)";
//       } else if (yearlyCurrencyView === 'etb') {
//         title += " (ETB)";
//       } else {
//         title += " (USD + ETB)";
//       }
//       return title;
//     };
    
//     const getCurrencySymbol = () => {
//       if (yearlyCurrencyView === 'usd') return "$";
//       if (yearlyCurrencyView === 'etb') return "ETB";
//       return yearlyCurrencyView === 'both' ? "$" : "";
//     };
    
//     const renderYearlyChart = () => {
//       if (yearlyChartType === 'line') {
//         return (
//           <YearlyLineChart 
//             title={getChartTitle()}
//             yearlyData={displayData}
//             currencySymbol={getCurrencySymbol()}
//             currencyType={yearlyCurrencyView}
//           />
//         );
//       } else {
//         return (
//           <YearlyBarChart 
//             title={getChartTitle()}
//             yearlyData={displayData}
//             currencySymbol={getCurrencySymbol()}
//             currencyType={yearlyCurrencyView}
//           />
//         );
//       }
//     };
    
//     return (
//       <Box sx={{ mt: 2, mb: 3 }}>
//         {/* Controls for Yearly Chart */}
//         <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
//           <Grid container spacing={2} alignItems="center">
//             <Grid item xs={12} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>Select Park</InputLabel>
//                 <Select
//                   value={selectedParkForYearly}
//                   onChange={(e) => setSelectedParkForYearly(e.target.value)}
//                   label="Select Park"
//                 >
//                   <MenuItem value="all">All Parks (Summary)</MenuItem>
//                   {parksListForYearly.map((park) => (
//                     <MenuItem key={park} value={park}>{park}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} md={2}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Typography variant="body2" color="textSecondary">Chart Type:</Typography>
//                 <ToggleButtonGroup
//                   value={yearlyChartType}
//                   exclusive
//                   onChange={(e, val) => val && setYearlyChartType(val)}
//                   size="small"
//                 >
//                   <ToggleButton value="line">
//                     <Tooltip title="Line Chart"><ShowChartIcon fontSize="small" /></Tooltip>
//                   </ToggleButton>
//                   <ToggleButton value="bar">
//                     <Tooltip title="Bar Chart"><BarChartIcon fontSize="small" /></Tooltip>
//                   </ToggleButton>
//                 </ToggleButtonGroup>
//               </Box>
//             </Grid>
            
//             <Grid item xs={12} md={3}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//   <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
//     Currency View:
//   </Typography>
//   <ToggleButtonGroup
//     value={yearlyCurrencyView}
//     exclusive
//     onChange={(e, val) => val && setYearlyCurrencyView(val)}
//     size="small"
//     aria-label="currency view"
//   >
//     <ToggleButton value="both" aria-label="both currencies">
//       Both
//     </ToggleButton>
//     <ToggleButton value="usd" aria-label="USD only">
//       USD Only
//     </ToggleButton>
//     <ToggleButton value="etb" aria-label="ETB only">
//       ETB Only
//     </ToggleButton>
//   </ToggleButtonGroup>
// </Box>
//             </Grid>
//           </Grid>
//         </Paper>
        
//         {/* Yearly Chart Display */}
//         <Paper elevation={1} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
//           {Object.keys(displayData).length === 0 ? (
//             <Box sx={{ p: 5, textAlign: 'center' }}>
//               <Typography variant="body2" color="textSecondary">
//                 No yearly data available for the selected filters
//               </Typography>
//             </Box>
//           ) : (
//             renderYearlyChart()
//           )}
//         </Paper>
//       </Box>
//     );
//   };

//   // Main Chart Component
//   const SimpleChart = () => {
//     const combinedChartData = getCombinedChartData();
//     const usdChartData = getChartDataByCurrency('USD');
//     const etbChartData = getChartDataByCurrency('ETB');
    
//     return (
//         <Box sx={{ mt: 2, mb: 3 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//   <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
//     Currency View:
//   </Typography>
//   <ToggleButtonGroup
//     value={chartCurrency}
//     exclusive
//     onChange={(e, val) => val && setChartCurrency(val)}
//     size="small"
//     aria-label="currency view"
//     sx={{
//       '& .MuiToggleButton-root': {
//         borderColor: 'gray',
//         color: 'gray',
//         textTransform: 'none',
//         backgroundColor: 'transparent',
//         '&:hover': {
//           backgroundColor: '#f5f5f5',
//           borderColor: '#1976d2',
//         },
//         '&.Mui-selected': {
//           backgroundColor: '#e0e0e0',
//           color: 'black',
//           borderColor: 'gray',
//           '&:hover': {
//             backgroundColor: '#e0e0e0',
//           }
//         }
//       }
//     }}
//   >
//     <ToggleButton value="both" aria-label="both currencies">
//       Both
//     </ToggleButton>
//     <ToggleButton value="USD" aria-label="USD only">
//       USD Only
//     </ToggleButton>
//     <ToggleButton value="ETB" aria-label="ETB only">
//       ETB Only
//     </ToggleButton>
//   </ToggleButtonGroup>
// </Box>
        
//         <Paper elevation={1} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
//           {chartCurrency === 'both' ? (
//             chartType === 'bar' ? (
//               <CombinedBarChart data={combinedChartData} />
//             ) : chartType === 'line' ? (
//               <CombinedLineChart data={combinedChartData} />
//             ) : (
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={6}>
//                   <Paper variant="outlined" sx={{ p: 1 }}>
//                     <SingleCurrencyChart 
//                       title="USD Revenue by Park"
//                       data={usdChartData} 
//                       totalAmount={totalUSD}
//                       currencySymbol="$"
//                       chartType={chartType}
//                     />
//                   </Paper>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Paper variant="outlined" sx={{ p: 1 }}>
//                     <SingleCurrencyChart 
//                       title="ETB Revenue by Park"
//                       data={etbChartData} 
//                       totalAmount={totalETB}
//                       currencySymbol="ETB"
//                       chartType={chartType}
//                     />
//                   </Paper>
//                 </Grid>
//               </Grid>
//             )
//           ) : chartCurrency === 'USD' ? (
//             <SingleCurrencyChart 
//               title="USD Revenue by Park"
//               data={usdChartData} 
//               totalAmount={totalUSD}
//               currencySymbol="$"
//               chartType={chartType}
//             />
//           ) : (
//             <SingleCurrencyChart 
//               title="ETB Revenue by Park"
//               data={etbChartData} 
//               totalAmount={totalETB}
//               currencySymbol="ETB"
//               chartType={chartType}
//             />
//           )}
//         </Paper>
//       </Box>
//     );
//   };

//   return (
//     <Box sx={{ width: '100%', bgcolor: '#f5f5f5', minHeight: '100vh', p: 3 }}>
//       {/* Header Section */}
//       <Typography variant="h6" gutterBottom sx={{ color: '#1a237e', fontWeight: 'bold', textAlign: 'center', mb: 1 }}>
//         Revenue Report Dashboard
//       </Typography>
//       <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', mb: 3 }}>
//         Track and analyze revenue across all industrial parks
//       </Typography>
      
//       {/* Summary Cards */}
//       <Grid container spacing={2} sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
//         <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
//           <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
//             <CardContent sx={{ py: 1, '&:last-child': { pb: 1 }, textAlign: 'center' }}>
//               <TrendingUpIcon sx={{ color: '#2e7d32', fontSize: 18 }} />
//               <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem', display: 'block' }}>
//                 Total Revenue
//               </Typography>
//               <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, my: 0.5 }}>
//                 <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 'normal', fontSize: '0.8rem' }}>
//                   USD: ${formatNumber(totalUSD)}
//                 </Typography>
//                 <Box sx={{ width: '1px', height: '16px', bgcolor: '#ddd' }} />
//                 <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 'normal', fontSize: '0.8rem' }}>
//                   ETB: {formatNumber(totalETB)} ETB
//                 </Typography>
//               </Box>
//               <Typography variant="caption" sx={{ color: '#999', fontSize: '0.65rem', display: 'block', mt: 0.5 }}>
//                 Across all parks
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
//           <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
//             <CardContent sx={{ py: 1, '&:last-child': { pb: 1 }, textAlign: 'center' }}>
//               <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem', display: 'block' }}>
//                 Total Transactions
//               </Typography>
//               <Typography variant="body2" sx={{ my: 0.5, color: '#1976d2', fontWeight: 'normal', fontSize: '0.9rem' }}>
//                 {summaryStats.totalTransactions}
//               </Typography>
//               <Typography variant="caption" sx={{ color: '#999', fontSize: '0.65rem', display: 'block', mt: 0.5 }}>
//                 All time
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
//           <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
//             <CardContent sx={{ py: 1, '&:last-child': { pb: 1 }, textAlign: 'center' }}>
//               <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem', display: 'block' }}>
//                 Active Companies
//               </Typography>
//               <Typography variant="body2" sx={{ my: 0.5, color: '#1976d2', fontWeight: 'normal', fontSize: '0.9rem' }}>
//                 {summaryStats.uniqueCompanies}
//               </Typography>
//               <Typography variant="caption" sx={{ color: '#999', fontSize: '0.65rem', display: 'block', mt: 0.5 }}>
//                 Currently active
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
      
//       {/* Filters Section */}
//       <Paper elevation={2} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
//         <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
//           <Grid item xs={12} md={4}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder="Search by company, transaction ID..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon />
//                   </InputAdornment>
//                 ),
//                 endAdornment: searchTerm && (
//                   <InputAdornment position="end">
//                     <ClearIcon
//                       sx={{ cursor: 'pointer' }}
//                       onClick={() => setSearchTerm("")}
//                     />
//                   </InputAdornment>
//                 )
//               }}
//             />
//           </Grid>
          
//           <Grid item xs={12} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Park</InputLabel>
//               <Select
//                 value={selectedPark}
//                 onChange={(e) => setSelectedPark(e.target.value)}
//                 label="Park"
//               >
//                 <MenuItem value="all">All Parks</MenuItem>
//                 {parksList.map((park) => (
//                   <MenuItem key={park} value={park}>{park}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Currency</InputLabel>
//               <Select
//                 value={selectedCurrency}
//                 onChange={(e) => setSelectedCurrency(e.target.value)}
//                 label="Currency"
//               >
//                 <MenuItem value="all">All</MenuItem>
//                 <MenuItem value="usd">USD</MenuItem>
//                 <MenuItem value="birr">Birr</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>

//           <Grid item xs={12} md={2}>
//             <Box sx={{ display: 'flex', gap: 1 }}>
//               <Button
//                 fullWidth
//                 variant="outlined"
//                 onClick={resetFilters}
//                 startIcon={<ClearIcon />}
//                 size="small"
//                 sx={{ 
//                   textTransform: 'none',
//                   borderColor: '#1976d2',
//                   color: '#1976d2',
//                   '&:hover': {
//                     borderColor: '#1565c0',
//                     backgroundColor: 'rgba(25, 118, 210, 0.04)',
//                   },
//                 }}
//               >
//                 Reset
//               </Button>
//               <Button
//                 fullWidth
//                 variant="contained"
//                 color="inherit"
//                 size="small"
//                 onClick={handleExportCSV}
//                 startIcon={<DownloadIcon />}
//                 sx={{ textTransform: 'none' }}
//               >
//                 Export
//               </Button>
//             </Box>
//           </Grid>
//         </Grid>
        
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} sm={6} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Year From</InputLabel>
//               <Select
//                 value={startYear}
//                 onChange={(e) => setStartYear(e.target.value)}
//                 label="Year From"
//               >
//                 {years.map((year) => (
//                   <MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} sm={6} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Year To</InputLabel>
//               <Select
//                 value={endYear}
//                 onChange={(e) => setEndYear(e.target.value)}
//                 label="Year To"
//               >
//                 {years.map((year) => (
//                   <MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} sm={6} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Month From</InputLabel>
//               <Select
//                 value={startMonth}
//                 onChange={(e) => setStartMonth(e.target.value)}
//                 label="Month From"
//               >
//                 {months.map((month) => (
//                   <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} sm={6} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Month To</InputLabel>
//               <Select
//                 value={endMonth}
//                 onChange={(e) => setEndMonth(e.target.value)}
//                 label="Month To"
//               >
//                 {months.map((month) => (
//                   <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} md={2}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
//                 Chart Type:
//               </Typography>
//               <ToggleButtonGroup
//                 value={chartType}
//                 exclusive
//                 onChange={handleChartTypeChange}
//                 size="small"
//                 aria-label="chart type"
//               >
//                 <ToggleButton value="bar" aria-label="bar chart">
//                   <Tooltip title="Bar Chart">
//                     <BarChartIcon fontSize="small" />
//                   </Tooltip>
//                 </ToggleButton>
//                 <ToggleButton value="line" aria-label="line chart">
//                   <Tooltip title="Line Chart">
//                     <ShowChartIcon fontSize="small" />
//                   </Tooltip>
//                 </ToggleButton>
//                 <ToggleButton value="pie" aria-label="pie chart">
//                   <Tooltip title="Pie Chart">
//                     <PieChartIcon fontSize="small" />
//                   </Tooltip>
//                 </ToggleButton>
//               </ToggleButtonGroup>
//             </Box>
//           </Grid>
          
//           <Grid item xs={12} md={2}>
//             <Button
//               variant="outlined"
//               size="small"
//               onClick={() => setShowChart(!showChart)}
//               sx={{ 
//                 minWidth: '100px',
//                 textTransform: 'none',
//                 borderColor: '#1976d2',
//                 color: '#1976d2',
//                 '&:hover': { 
//                   borderColor: '#1976d2',
//                   backgroundColor: '#f5f5f5',
//                   color: '#1976d2'
//                 }
//               }}
//             >
//               {showChart ? "Hide Chart" : "Show Chart"}
//             </Button>
//           </Grid>
//         </Grid>
//       </Paper>
      
//       {/* Conditional Rendering: Show Chart OR Table */}
//       {showChart ? (
//         <>
//           {/* Chart Type Toggle Buttons */}
//           <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
//           <Button
//   variant={!showYearlyChart ? 'contained' : 'outlined'}
//   size="small"
//   onClick={() => setShowYearlyChart(false)}
//   sx={{ 
//     textTransform: 'none',
//     minWidth: '120px',
//     borderColor: '#1976d2',
//     color: '#1976d2',
//     ...(!showYearlyChart ? {
//       backgroundColor: '#e0e0e0',
//       '&:hover': {
//         backgroundColor: '#e0e0e0',
//       }
//     } : {
//       backgroundColor: 'transparent',
//       '&:hover': {
//         backgroundColor: '#e0e0e0',
//       }
//     })
//   }}
// >
//   By Park
// </Button>

// <Button
//   variant={showYearlyChart ? 'contained' : 'outlined'}
//   size="small"
//   onClick={() => setShowYearlyChart(true)}
//   sx={{ 
//     textTransform: 'none',
//     minWidth: '120px',
//     borderColor: '#1976d2',
//     color: '#1976d2',
//     ...(showYearlyChart ? {
//       backgroundColor: '#e0e0e0',
//       '&:hover': {
//         backgroundColor: '#e0e0e0',
//       }
//     } : {
//       backgroundColor: 'transparent',
//       '&:hover': {
//         backgroundColor: '#e0e0e0',
//       }
//     })
//   }}
// >
//   Yearly Trend
// </Button>
// </Box>
          
//           {!showYearlyChart ? (
//             <SimpleChart />
//           ) : (
//             <YearlyChartDashboard />
//           )}
//         </>
//       ) : (
//         <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
//           {loading ? (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
//               <CircularProgress />
//               <Typography sx={{ ml: 2 }}>Loading revenue data...</Typography>
//             </Box>
//           ) : filteredData.length === 0 ? (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
//               <Typography sx={{ color: 'text.secondary' }}>No revenue data available</Typography>
//             </Box>
//           ) : (
//             <>
//               <Box sx={{ p: 2, bgcolor: '#fafafa', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
//                   Revenue Records
//                 </Typography>
//                 <Typography variant="body2" color="textSecondary">
//                   Showing {filteredData.length} of {revenueData.length} records
//                 </Typography>
//               </Box>
              
//               <TableContainer>
//                 <Table size="small">
//                   <TableHead sx={{ bgcolor: '#f5f5f5' }}>
//                     <TableRow>
//                       <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Transaction ID</TableCell>
//                       <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Company Name</TableCell>
//                       <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Park</TableCell>
//                       <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Payment Mode</TableCell>
//                       <TableCell align="right" sx={{ py: 1, fontWeight: 'bold' }}>Amount</TableCell>
//                       <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Transaction Date</TableCell>
//                       <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Revenue Type</TableCell>
//                       <TableCell align="center" sx={{ py: 1, fontWeight: 'bold' }}>Actions</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {getCurrentPageData().map((row) => (
//                       <TableRow key={row.id} hover>
//                         <TableCell sx={{ py: 0.5 }}>{row.transaction_id}</TableCell>
//                         <TableCell sx={{ py: 0.5 }}>{row.company_name}</TableCell>
//                         <TableCell sx={{ py: 0.5 }}>{row.park_name}</TableCell>
//                         <TableCell sx={{ py: 0.5 }}>{row.payment_mode}</TableCell>
//                         <TableCell align="right" sx={{ py: 0.5, color: '#2e7d32', fontWeight: 'bold' }}>
//                           {row.formattedAmount}
//                         </TableCell>
//                         <TableCell sx={{ py: 0.5 }}>{row.transaction_date_formatted}</TableCell>
//                         <TableCell sx={{ py: 0.5 }}>{row.revenue_type}</TableCell>
//                         <TableCell align="center" sx={{ py: 0.5 }}>
//                           <Tooltip title="View Details">
//                             <IconButton
//                               size="small"
//                               color="primary"
//                               onClick={() => handleViewDetails(row)}
//                             >
//                               <VisibilityIcon />
//                             </IconButton>
//                           </Tooltip>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
              
//               <TablePagination
//                 rowsPerPageOptions={[5, 10, 25, 50]}
//                 component="div"
//                 count={filteredData.length}
//                 rowsPerPage={rowsPerPage}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//               />
              
//               <Box sx={{ 
//                 p: 2, 
//                 bgcolor: '#fafafa', 
//                 borderTop: '1px solid #e0e0e0',
//                 display: 'flex',
//                 justifyContent: 'flex-end',
//                 alignItems: 'center',
//                 gap: 3
//               }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold' }}>
//                     Summary: {`Total Records: ${filteredData.length}`} | {' '}
//                     {`Total USD: $${formatNumber(totalUSD)}`} | {' '}
//                     {`Total ETB: ${formatNumber(totalETB)} ETB`}
//                   </Typography>
//                 </Box>
//               </Box>
//             </>
//           )}
//         </Paper>
//       )}
      
//       {/* Details Dialog */}
//       <Dialog open={openDetailsDialog} onClose={() => setOpenDetailsDialog(false)} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h5" sx={{ color: 'black', fontWeight: 'normal' }}>
//               Revenue Transaction Details
//             </Typography>
//             <IconButton onClick={() => setOpenDetailsDialog(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <Divider />
//         <DialogContent>
//           {selectedRevenue && (
//             <Box sx={{ mt: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Transaction ID:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedRevenue.transaction_id}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Company Name:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedRevenue.company_name}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Park Name:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedRevenue.park_name}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Payment Mode:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedRevenue.payment_mode}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Amount:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: '#2e7d32', fontWeight: 'bold' }}>
//                       {selectedRevenue.formattedAmount}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Transaction Date:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedRevenue.transaction_date_formatted}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Revenue Type:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedRevenue.revenue_type}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Year/Month:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedRevenue.year} - {selectedRevenue.month}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Payment Status:
//                     </Typography>
//                     <Chip 
//                       label={selectedRevenue.payment_status} 
//                       size="small" 
//                       color={selectedRevenue.payment_status === "Completed" ? "success" : "warning"}
//                     />
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Invoice Number:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedRevenue.invoice_number}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 {selectedRevenue.description && (
//                   <Grid item xs={12}>
//                     <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                       <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                         Description:
//                       </Typography>
//                       <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                         {selectedRevenue.description}
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
//           <Button onClick={() => setOpenDetailsDialog(false)} variant="outlined" sx={{ color: 'black', borderColor: '#ccc' }}>Close</Button>
//         </Box>
//       </Dialog>
//     </Box>
//   );
// }
//************************************************************************* */
import { useEffect, useState, useRef, useCallback } from "react";
import {
  Tabs,
  Tab,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Chip,
  Divider,
  Alert,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  ToggleButton,
  ToggleButtonGroup
} from "@mui/material";
import {
  PictureAsPdf as PdfIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  WarningAmber as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Download as DownloadIcon,
  Visibility as VisibilityIcon,
  Print as PrintIcon,
  Payment as PaymentIcon,
  Close as CloseIcon,
  BarChart as BarChartIcon,
  ShowChart as ShowChartIcon,
  PieChart as PieChartIcon,
  TrendingUp as TrendingUpIcon,
  Timeline as TimelineIcon
} from "@mui/icons-material";
import { format } from "date-fns";
import { ExecutePostWithParams, GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

// Helper function to normalize currency values
const normalizeCurrency = (paymentMode) => {
  if (!paymentMode) return "unknown";
  const mode = paymentMode.toLowerCase();
  if (mode === "usd") return "usd";
  if (mode === "birr" || mode === "etb") return "birr";
  return mode;
};

// Format number with K, M, B abbreviations for data visualization (Cards only)
const formatNumberWithAbbreviation = (number) => {
  const num = toNumber(number);
  if (num === 0) return "0";
  
  const absNum = Math.abs(num);
  let formattedValue;
  let suffix = '';
  
  if (absNum >= 1e9) {
    formattedValue = (num / 1e9).toFixed(1);
    suffix = 'B';
  } else if (absNum >= 1e6) {
    formattedValue = (num / 1e6).toFixed(1);
    suffix = 'M';
  } else if (absNum >= 1e3) {
    formattedValue = (num / 1e3).toFixed(1);
    suffix = 'K';
  } else {
    formattedValue = num.toFixed(0);
  }
  
  // Remove .0 if it exists
  if (formattedValue.endsWith('.0')) {
    formattedValue = formattedValue.slice(0, -2);
  }
  
  return formattedValue + suffix;
};

// Helper function to normalize currency values
const toNumber = (value) => {
  if (typeof value === 'number' && !isNaN(value)) return value;
  if (typeof value === 'string') {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }
  return 0;
};

// Format for card display with abbreviations
const formatCurrencyForCard = (amount, paymentMode) => {
  const formatted = formatNumberWithAbbreviation(amount);
  const normalizedMode = normalizeCurrency(paymentMode);
  
  if (normalizedMode === "usd") {
    return `$${formatted}`;
  } else {
    return `${formatted} ETB`;
  }
};

// Format for table and chart views (full number)
const formatCurrency = (amount, paymentMode) => {
  const formatted = formatNumber(amount);
  const normalizedMode = normalizeCurrency(paymentMode);
  
  if (normalizedMode === "usd") {
    return `$${formatted}`;
  } else {
    return `${formatted} ETB`;
  }
};

const formatNumber = (number) => {
  let num = 0;
  
  if (number !== null && number !== undefined) {
    if (typeof number === 'string') {
      const cleaned = number.replace(/[$,]/g, '');
      num = parseFloat(cleaned);
    } else {
      num = parseFloat(number);
    }
    
    if (isNaN(num)) {
      num = 0;
    }
  }
  
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
};

const formatDate = (date) => {
  if (!date) return "N/A";
  try {
    return format(new Date(date), 'dd/MM/yyyy');
  } catch {
    return "Invalid Date";
  }
};

// Tab Panel Component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`revenue-tabpanel-${index}`}
      aria-labelledby={`revenue-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function RevenueReport() {
  // State Management
  const [tabValue, setTabValue] = useState(0);
  const [revenueData, setRevenueData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // Filter States
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPark, setSelectedPark] = useState("all");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedCurrency, setSelectedCurrency] = useState("all");
  const [selectedYear, setSelectedYear] = useState("all");
  const [selectedMonth, setSelectedMonth] = useState("all");
  
  // Year Range and Month Range States
  const [startYear, setStartYear] = useState("all");
  const [endYear, setEndYear] = useState("all");
  const [startMonth, setStartMonth] = useState("all");
  const [endMonth, setEndMonth] = useState("all");
  
  const [parksList, setParksList] = useState([]);
  
  // Chart States
  const [chartType, setChartType] = useState('bar');
  const [showChart, setShowChart] = useState(false);
  const [chartCurrency, setChartCurrency] = useState('both');
  const [showYearlyChart, setShowYearlyChart] = useState(false);
  const [selectedParkForYearly, setSelectedParkForYearly] = useState("all");
  
  // Dialog States
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [selectedRevenue, setSelectedRevenue] = useState(null);

  // Years and Months for filtering
  // Generate last 10 years dynamically
const getLastNYears = (n) => {
    const currentYear = new Date().getFullYear();
    const years = ["all"];
    for (let i = 0; i < n; i++) {
      years.push((currentYear - i).toString());
    }
    return years;
  };
  
  // Usage in your component
  const years = getLastNYears(10);
  const months = [
    { value: "all", label: "All Months" },
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" }
  ];

  // Fetch revenue data from API
  useEffect(() => {
    const fetchRevenue = async () => {
      setLoading(true);
      try {
        const resultData = await GetDataFromApiWithParams(`finances/revenuereport`);
        console.log("Revenue Response:", resultData);
        
        let dataArray = [];
        if (resultData && Array.isArray(resultData)) {
          dataArray = resultData;
        } else if (resultData && resultData.data && Array.isArray(resultData.data)) {
          dataArray = resultData.data;
        } else if (resultData && resultData.results && Array.isArray(resultData.results)) {
          dataArray = resultData.results;
        } else if (resultData && resultData.items && Array.isArray(resultData.items)) {
          dataArray = resultData.items;
        } else if (resultData && resultData.records && Array.isArray(resultData.records)) {
          dataArray = resultData.records;
        } else if (resultData && typeof resultData === 'object') {
          for (let key in resultData) {
            if (Array.isArray(resultData[key])) {
              dataArray = resultData[key];
              console.log(`Found array in property: ${key}`);
              break;
            }
          }
        }
        
        console.log("Extracted data array:", dataArray);
        
        if (dataArray.length > 0) {
          const formattedData = dataArray.map((item, index) => {
            let revenueAmount = 0;
            
            if (item.payment_amount !== undefined && item.payment_amount !== null) {
              if (typeof item.payment_amount === 'number') {
                revenueAmount = item.payment_amount;
              } else if (typeof item.payment_amount === 'string') {
                const cleaned = item.payment_amount.replace(/,/g, '');
                revenueAmount = parseFloat(cleaned);
                if (isNaN(revenueAmount)) revenueAmount = 0;
              } else {
                revenueAmount = parseFloat(item.payment_amount);
                if (isNaN(revenueAmount)) revenueAmount = 0;
              }
            }
            else if (item.amount !== undefined && item.amount !== null) {
              revenueAmount = parseFloat(item.amount);
              if (isNaN(revenueAmount)) revenueAmount = 0;
            } else if (item.revenue !== undefined && item.revenue !== null) {
              revenueAmount = parseFloat(item.revenue);
              if (isNaN(revenueAmount)) revenueAmount = 0;
            }
            
            let paymentMode = "ETB";
            if (item.payment_mode) {
              paymentMode = item.payment_mode;
            } else if (item.currency) {
              paymentMode = item.currency;
            }
            
            let transactionDate = item.transaction_date || item.date || item.payment_date || item.created_at;
            let month = item.month;
            let year = item.year;
            
            if (transactionDate && !month) {
              try {
                const dateObj = new Date(transactionDate);
                if (!isNaN(dateObj.getTime())) {
                  month = format(dateObj, 'MM');
                  year = format(dateObj, 'yyyy');
                }
              } catch (e) {
                console.warn("Date parsing error:", e);
              }
            }
            
            // Use full format for table display
            const formattedAmount = formatCurrency(revenueAmount, paymentMode);
            
            return {
              id: item.id || item.revenue_id || item.transaction_id || index,
              transaction_id: item.transaction_id || item.id || `TRX-${index}`,
              company_name: item.company_name || item.tenant_name || item.customer_name || "N/A",
              park_name: item.park || item.park_name || item.location || "N/A",
              payment_mode: paymentMode,
              amount: revenueAmount,
              formattedAmount: formattedAmount,
              transaction_date: transactionDate,
              transaction_date_formatted: transactionDate ? formatDate(transactionDate) : "N/A",
              revenue_type: item.payment_type || item.revenue_type || item.type || item.category || "Rent",
              payment_status: item.payment_status || item.status || "Completed",
              tenant_name: item.company_name || item.tenant_name || "N/A",
              invoice_number: item.invoice_number || item.invoice_no || `INV-${index}`,
              description: item.description || item.notes || `Revenue from ${item.company_name || 'Unknown'}`,
              month: month || "01",
              year: year || "2024",
              upin: item.upin || "N/A",
              contact_number: item.contact_number || item.phone || "N/A",
              email: item.email || "N/A"
            };
          });
          
          console.log("Final formatted data:", formattedData);
          setRevenueData(formattedData);
          setFilteredData(formattedData);
          
          const uniqueParks = [...new Set(formattedData.map(item => item.park_name).filter(Boolean))];
          setParksList(uniqueParks);
        } else {
          console.log("No revenue data received or invalid format");
          setRevenueData([]);
          setFilteredData([]);
        }
      } catch (error) {
        console.error("Failed to fetch revenue data:", error);
        setRevenueData([]);
        setFilteredData([]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchRevenue();
  }, []);

  // Calculate summary statistics using normalized currency
  const summaryStats = {
    totalRevenue: filteredData.reduce((sum, item) => sum + (item.amount || 0), 0),
    totalTransactions: filteredData.length,
    averageTransaction: filteredData.length > 0 ? filteredData.reduce((sum, item) => sum + (item.amount || 0), 0) / filteredData.length : 0,
    uniqueCompanies: new Set(filteredData.map(item => item.company_name)).size,
    completedPayments: filteredData.filter(item => item.payment_status === "Completed").length,
    pendingPayments: filteredData.filter(item => item.payment_status === "Pending").length
  };

  const totalUSD = filteredData
    .filter(item => normalizeCurrency(item.payment_mode) === "usd")
    .reduce((sum, item) => sum + (item.amount || 0), 0);

  const totalETB = filteredData
    .filter(item => normalizeCurrency(item.payment_mode) === "birr")
    .reduce((sum, item) => sum + (item.amount || 0), 0);

  // Chart data preparation for combined currencies
  const getCombinedChartData = () => {
    const parkData = {};
    
    filteredData.forEach(item => {
      if (!parkData[item.park_name]) {
        parkData[item.park_name] = {
          usdRevenue: 0,
          etbRevenue: 0,
          totalRevenue: 0,
          transactionCount: 0,
          usdTransactionCount: 0,
          etbTransactionCount: 0
        };
      }
      
      const amount = item.amount || 0;
      const normalizedMode = normalizeCurrency(item.payment_mode);
      
      if (normalizedMode === "usd") {
        parkData[item.park_name].usdRevenue += amount;
        parkData[item.park_name].usdTransactionCount++;
      } else if (normalizedMode === "birr") {
        parkData[item.park_name].etbRevenue += amount;
        parkData[item.park_name].etbTransactionCount++;
      }
      
      parkData[item.park_name].totalRevenue += amount;
      parkData[item.park_name].transactionCount++;
    });
    
    return parkData;
  };

  const getChartDataByCurrency = (currency) => {
    const parkData = {};
    const filteredByCurrency = filteredData.filter(item => {
      const normalizedMode = normalizeCurrency(item.payment_mode);
      if (currency.toLowerCase() === 'usd') {
        return normalizedMode === 'usd';
      } else {
        return normalizedMode === 'birr';
      }
    });
    
    filteredByCurrency.forEach(item => {
      if (!parkData[item.park_name]) {
        parkData[item.park_name] = {
          totalRevenue: 0,
          transactionCount: 0
        };
      }
      parkData[item.park_name].totalRevenue += item.amount || 0;
      parkData[item.park_name].transactionCount++;
    });
    return parkData;
  };

  // Prepare yearly chart data by park
  const getYearlyChartDataByPark = () => {
    const yearlyData = {};
    
    filteredData.forEach(item => {
      const year = item.year;
      const park = item.park_name;
      const amount = item.amount || 0;
      const normalizedMode = normalizeCurrency(item.payment_mode);
      
      if (!yearlyData[year]) {
        yearlyData[year] = {};
      }
      
      if (!yearlyData[year][park]) {
        yearlyData[year][park] = {
          usdRevenue: 0,
          etbRevenue: 0,
          totalRevenue: 0
        };
      }
      
      if (normalizedMode === "usd") {
        yearlyData[year][park].usdRevenue += amount;
      } else if (normalizedMode === "birr") {
        yearlyData[year][park].etbRevenue += amount;
      }
      
      yearlyData[year][park].totalRevenue += amount;
    });
    
    return yearlyData;
  };

  // Prepare yearly summary data (total per year by currency)
  const getYearlySummaryData = () => {
    const yearlySummary = {};
    
    filteredData.forEach(item => {
      const year = item.year;
      const amount = item.amount || 0;
      const normalizedMode = normalizeCurrency(item.payment_mode);
      
      if (!yearlySummary[year]) {
        yearlySummary[year] = {
          usdRevenue: 0,
          etbRevenue: 0,
          totalRevenue: 0,
          transactionCount: 0
        };
      }
      
      if (normalizedMode === "usd") {
        yearlySummary[year].usdRevenue += amount;
      } else if (normalizedMode === "birr") {
        yearlySummary[year].etbRevenue += amount;
      }
      
      yearlySummary[year].totalRevenue += amount;
      yearlySummary[year].transactionCount++;
    });
    
    // Sort years in descending order
    const sortedYears = Object.keys(yearlySummary).sort((a, b) => b - a);
    const sortedSummary = {};
    sortedYears.forEach(year => {
      sortedSummary[year] = yearlySummary[year];
    });
    
    return sortedSummary;
  };

  // Prepare yearly data for a specific park
  const getYearlyDataForPark = (parkName) => {
    const parkYearlyData = {};
    
    filteredData.forEach(item => {
      if (item.park_name === parkName) {
        const year = item.year;
        const amount = item.amount || 0;
        const normalizedMode = normalizeCurrency(item.payment_mode);
        
        if (!parkYearlyData[year]) {
          parkYearlyData[year] = {
            usdRevenue: 0,
            etbRevenue: 0,
            totalRevenue: 0
          };
        }
        
        if (normalizedMode === "usd") {
          parkYearlyData[year].usdRevenue += amount;
        } else if (normalizedMode === "birr") {
          parkYearlyData[year].etbRevenue += amount;
        }
        
        parkYearlyData[year].totalRevenue += amount;
      }
    });
    
    // Sort years
    const sortedYears = Object.keys(parkYearlyData).sort((a, b) => a - b);
    const sortedData = {};
    sortedYears.forEach(year => {
      sortedData[year] = parkYearlyData[year];
    });
    
    return sortedData;
  };

  // Filter Data with Year Range and Month Range
  const applyFilters = useCallback(() => {
    let filtered = [...revenueData];
    
    if (searchTerm) {
      filtered = filtered.filter(item =>
        item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.transaction_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.park_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.invoice_number?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    if (selectedPark !== "all") {
      filtered = filtered.filter(item => item.park_name === selectedPark);
    }
    
    if (selectedStatus !== "all") {
      filtered = filtered.filter(item => item.payment_status === selectedStatus);
    }
    
    if (selectedCurrency !== "all") {
      filtered = filtered.filter(item => 
        normalizeCurrency(item.payment_mode) === selectedCurrency
      );
    }
    
    // YEAR RANGE FILTER
    if (startYear !== "all" || endYear !== "all") {
      filtered = filtered.filter(item => {
        const itemYear = parseInt(item.year);
        
        let startYearNum = startYear !== "all" ? parseInt(startYear) : -Infinity;
        let endYearNum = endYear !== "all" ? parseInt(endYear) : Infinity;
        
        return itemYear >= startYearNum && itemYear <= endYearNum;
      });
    }
    
    // MONTH RANGE FILTER
    if (startMonth !== "all" || endMonth !== "all") {
      filtered = filtered.filter(item => {
        const itemMonth = parseInt(item.month);
        
        let startMonthNum = startMonth !== "all" ? parseInt(startMonth) : 1;
        let endMonthNum = endMonth !== "all" ? parseInt(endMonth) : 12;
        
        return itemMonth >= startMonthNum && itemMonth <= endMonthNum;
      });
    }
    
    // Keep single year filter for backward compatibility
    if (selectedYear !== "all" && startYear === "all" && endYear === "all") {
      filtered = filtered.filter(item => item.year === selectedYear);
    }
    
    // Keep single month filter for backward compatibility
    if (selectedMonth !== "all" && startMonth === "all" && endMonth === "all") {
      filtered = filtered.filter(item => item.month === selectedMonth);
    }
    
    setFilteredData(filtered);
    setPage(0);
  }, [revenueData, searchTerm, selectedPark, selectedStatus, selectedCurrency, selectedYear, selectedMonth, startYear, endYear, startMonth, endMonth]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  // Handle View Details
  const handleViewDetails = (row) => {
    setSelectedRevenue(row);
    setOpenDetailsDialog(true);
  };

  // Reset Filters
  const resetFilters = () => {
    setSearchTerm("");
    setSelectedPark("all");
    setSelectedStatus("all");
    setSelectedCurrency("all");
    setSelectedYear("all");
    setSelectedMonth("all");
    setStartYear("all");
    setEndYear("all");
    setStartMonth("all");
    setEndMonth("all");
  };

  // Export to CSV
  const handleExportCSV = () => {
    if (filteredData.length === 0) {
      alert("No data to export");
      return;
    }
    
    const headers = ['Transaction ID', 'Company Name', 'Park Name', 'Payment Mode', 'Amount', 'Transaction Date', 'Revenue Type', 'Payment Status', 'Invoice Number', 'Year', 'Month'];
    const csvData = filteredData.map(item => [
      item.transaction_id,
      item.company_name,
      item.park_name,
      item.payment_mode,
      item.formattedAmount,
      item.transaction_date_formatted,
      item.revenue_type,
      item.payment_status,
      item.invoice_number,
      item.year,
      item.month
    ]);
    
    const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `revenue_report_${format(new Date(), 'yyyyMMdd')}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Get current page data
  const getCurrentPageData = () => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };

  // Handle chart type change
  const handleChartTypeChange = (event, newChartType) => {
    if (newChartType !== null) {
      setChartType(newChartType);
    }
  };

  // Yearly Line Chart Component
  const YearlyLineChart = ({ title, yearlyData, currencySymbol, currencyType }) => {
    const years = Object.keys(yearlyData).sort((a, b) => a - b);
    
    if (years.length === 0) {
      return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">
            No yearly data available
          </Typography>
        </Box>
      );
    }
    
    const maxValue = Math.max(
      ...Object.values(yearlyData).map(d => 
        currencyType === 'usd' ? (d.usdRevenue || 0) : 
        currencyType === 'etb' ? (d.etbRevenue || 0) : 
        (d.totalRevenue || 0)
      ),
      0
    );
    
    const chartHeight = 350;
    const chartWidth = Math.max(600, years.length * 100);
    const padding = { top: 30, right: 40, bottom: 60, left: 70 };
    
    return (
      <Box sx={{ p: 2, overflowX: 'auto' }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
          {title}
        </Typography>
        
        <svg width={chartWidth} height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
          {/* Grid lines */}
          {[0, 25, 50, 75, 100].map((percent) => {
            const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
            const value = (maxValue * percent) / 100;
            return (
              <g key={percent}>
                <line
                  x1={padding.left}
                  y1={y}
                  x2={chartWidth - padding.right}
                  y2={y}
                  stroke="#e0e0e0"
                  strokeWidth="1"
                  strokeDasharray="4"
                />
                <text
                  x={padding.left - 8}
                  y={y}
                  textAnchor="end"
                  fontSize="10"
                  fill="#666"
                >
                  {currencySymbol}{formatNumber(value)}
                </text>
              </g>
            );
          })}
          
          {/* Line */}
          <polyline
            points={years.map((year, index) => {
              const x = padding.left + (index / (years.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
              let revenueValue = 0;
              if (currencyType === 'usd') {
                revenueValue = yearlyData[year].usdRevenue || 0;
              } else if (currencyType === 'etb') {
                revenueValue = yearlyData[year].etbRevenue || 0;
              } else {
                revenueValue = yearlyData[year].totalRevenue || 0;
              }
              const y = chartHeight - padding.bottom - (revenueValue / maxValue) * (chartHeight - padding.top - padding.bottom);
              return `${x},${y}`;
            }).join(' ')}
            fill="none"
            stroke={currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0')}
            strokeWidth="2.5"
          />
          
          {/* Points and labels */}
          {years.map((year, index) => {
            const x = padding.left + (index / (years.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
            let revenueValue = 0;
            if (currencyType === 'usd') {
              revenueValue = yearlyData[year].usdRevenue || 0;
            } else if (currencyType === 'etb') {
              revenueValue = yearlyData[year].etbRevenue || 0;
            } else {
              revenueValue = yearlyData[year].totalRevenue || 0;
            }
            const y = chartHeight - padding.bottom - (revenueValue / maxValue) * (chartHeight - padding.top - padding.bottom);
            
            return (
              <g key={year}>
                <Tooltip
                  title={
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>Year: {year}</Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        {currencyType === 'usd' ? `USD Revenue: ${currencySymbol}${formatNumber(revenueValue)}` :
                         currencyType === 'etb' ? `ETB Revenue: ${currencySymbol}${formatNumber(revenueValue)}` :
                         `Total Revenue: ${currencySymbol}${formatNumber(revenueValue)}`}
                      </Typography>
                      {currencyType === 'both' && (
                        <>
                          <Typography variant="body2" sx={{ color: '#fff' }}>
                            USD: ${formatNumber(yearlyData[year].usdRevenue || 0)}
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#fff' }}>
                            ETB: {formatNumber(yearlyData[year].etbRevenue || 0)} ETB
                          </Typography>
                        </>
                      )}
                    </Box>
                  }
                  arrow
                  placement="top"
                >
                  <circle
                    cx={x}
                    cy={y}
                    r="6"
                    fill={currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0')}
                    stroke="white"
                    strokeWidth="2"
                    style={{ cursor: 'pointer' }}
                  />
                </Tooltip>
                <text
                  x={x}
                  y={chartHeight - padding.bottom + 20}
                  textAnchor="middle"
                  fontSize="11"
                  fontWeight="bold"
                >
                  {year}
                </text>
                <text
                  x={x}
                  y={y - 8}
                  textAnchor="middle"
                  fontSize="9"
                  fill="#666"
                >
                  {currencySymbol}{formatNumber(revenueValue)}
                </text>
              </g>
            );
          })}
          
          {/* Axes */}
          <line
            x1={padding.left}
            y1={padding.top}
            x2={padding.left}
            y2={chartHeight - padding.bottom}
            stroke="#999"
            strokeWidth="1.5"
          />
          <line
            x1={padding.left}
            y1={chartHeight - padding.bottom}
            x2={chartWidth - padding.right}
            y2={chartHeight - padding.bottom}
            stroke="#999"
            strokeWidth="1.5"
          />
          
          {/* Y-axis label */}
          <text
            x={20}
            y={chartHeight / 2}
            textAnchor="middle"
            fontSize="11"
            fill="#666"
            transform={`rotate(-90, 20, ${chartHeight / 2})`}
          >
            Revenue Amount
          </text>
          
          {/* X-axis label */}
          <text
            x={chartWidth / 2}
            y={chartHeight - 10}
            textAnchor="middle"
            fontSize="11"
            fill="#666"
          >
            Year
          </text>
        </svg>
        
        <Box sx={{ 
          width: '100%', 
          bgcolor: '#f5f5f5', 
          mt: 3,
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          p: 2,
          borderRadius: 1
        }}>
          <Typography variant="body2" color="textSecondary">
            Years: {years.join(' → ')}
          </Typography>
        </Box>
      </Box>
    );
  };

  // Yearly Bar Chart Component
  const YearlyBarChart = ({ title, yearlyData, currencySymbol, currencyType }) => {
    const years = Object.keys(yearlyData).sort((a, b) => a - b);
    
    if (years.length === 0) {
      return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">
            No yearly data available
          </Typography>
        </Box>
      );
    }
    
    const maxValue = Math.max(
      ...Object.values(yearlyData).map(d => 
        currencyType === 'usd' ? (d.usdRevenue || 0) : 
        currencyType === 'etb' ? (d.etbRevenue || 0) : 
        (d.totalRevenue || 0)
      ),
      0
    );
    
    const barColor = currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0');
    
    return (
      <Box sx={{ p: 2, overflowX: 'auto' }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
          {title}
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 3, minHeight: 350, justifyContent: 'center', flexWrap: 'wrap' }}>
          {years.map((year) => {
            let revenueValue = 0;
            if (currencyType === 'usd') {
              revenueValue = yearlyData[year].usdRevenue || 0;
            } else if (currencyType === 'etb') {
              revenueValue = yearlyData[year].etbRevenue || 0;
            } else {
              revenueValue = yearlyData[year].totalRevenue || 0;
            }
            
            const height = maxValue > 0 ? (revenueValue / maxValue) * 220 : 0;
            
            return (
              <Tooltip
                key={year}
                title={
                  <Box sx={{ p: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>Year: {year}</Typography>
                    <Typography variant="body2" sx={{ color: '#fff' }}>
                      {currencyType === 'usd' ? `USD Revenue: ${currencySymbol}${formatNumber(revenueValue)}` :
                       currencyType === 'etb' ? `ETB Revenue: ${currencySymbol}${formatNumber(revenueValue)}` :
                       `Total Revenue: ${currencySymbol}${formatNumber(revenueValue)}`}
                    </Typography>
                    {currencyType === 'both' && (
                      <>
                        <Typography variant="body2" sx={{ color: '#fff' }}>
                          USD: ${formatNumber(yearlyData[year].usdRevenue || 0)}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#fff' }}>
                          ETB: {formatNumber(yearlyData[year].etbRevenue || 0)} ETB
                        </Typography>
                      </>
                    )}
                  </Box>
                }
                arrow
                placement="top"
              >
                <Box sx={{ textAlign: 'center', minWidth: 80, cursor: 'pointer' }}>
                  <Box sx={{ 
                    height: height, 
                    width: '60px',
                    bgcolor: barColor,
                    borderRadius: '4px 4px 0 0',
                    margin: '0 auto',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      opacity: 0.8,
                      transform: 'translateY(-5px)',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                    }
                  }} />
                  <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
                    {year}
                  </Typography>
                  <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                    {currencySymbol}{formatNumber(revenueValue)}
                  </Typography>
                </Box>
              </Tooltip>
            );
          })}
        </Box>
        
        <Box sx={{ 
          width: '100%', 
          bgcolor: '#f5f5f5', 
          mt: 3,
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          p: 2,
          borderRadius: 1
        }}>
          <Typography variant="body2" color="textSecondary">
            Total Years: {years.length} | Range: {years[0]} - {years[years.length - 1]}
          </Typography>
        </Box>
      </Box>
    );
  };

  // Combined Line Chart Component (USD and ETB together)
  const CombinedLineChart = ({ data }) => {
    const parks = Object.keys(data);
    const maxUsdValue = Math.max(...Object.values(data).map(d => d.usdRevenue), 0);
    const maxEtbValue = Math.max(...Object.values(data).map(d => d.etbRevenue), 0);
    const maxValue = Math.max(maxUsdValue, maxEtbValue);
    
    if (parks.length === 0) {
      return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">
            No data available
          </Typography>
        </Box>
      );
    }
    
    const chartHeight = 350;
    const chartWidth = Math.max(800, parks.length * 80);
    const padding = { top: 30, right: 40, bottom: 80, left: 70 };
    
    return (
      <Box sx={{ p: 2, overflowX: 'auto' }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
          Revenue Trend Comparison by Park (USD vs ETB)
        </Typography>
        
        <svg width={chartWidth} height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
          {/* Grid lines */}
          {[0, 25, 50, 75, 100].map((percent) => {
            const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
            const value = (maxValue * percent) / 100;
            return (
              <g key={percent}>
                <line
                  x1={padding.left}
                  y1={y}
                  x2={chartWidth - padding.right}
                  y2={y}
                  stroke="#e0e0e0"
                  strokeWidth="1"
                  strokeDasharray="4"
                />
                <text
                  x={padding.left - 8}
                  y={y}
                  textAnchor="end"
                  fontSize="10"
                  fill="#666"
                >
                  {formatNumber(value)}
                </text>
              </g>
            );
          })}
          
          {/* USD Line */}
          <polyline
            points={parks.map((park, index) => {
              const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
              const y = chartHeight - padding.bottom - (data[park].usdRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
              return `${x},${y}`;
            }).join(' ')}
            fill="none"
            stroke="#1976d2"
            strokeWidth="2.5"
            strokeDasharray="0"
          />
          
          {/* ETB Line */}
          <polyline
            points={parks.map((park, index) => {
              const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
              const y = chartHeight - padding.bottom - (data[park].etbRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
              return `${x},${y}`;
            }).join(' ')}
            fill="none"
            stroke="#2e7d32"
            strokeWidth="2.5"
            strokeDasharray="0"
          />
          
          {/* Points and labels for both lines */}
          {parks.map((park, index) => {
            const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
            const yUsd = chartHeight - padding.bottom - (data[park].usdRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
            const yEtb = chartHeight - padding.bottom - (data[park].etbRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
            const totalAmount = data[park].usdRevenue + data[park].etbRevenue;
            const usdPercentage = totalAmount > 0 ? (data[park].usdRevenue / totalAmount) * 100 : 0;
            const etbPercentage = totalAmount > 0 ? (data[park].etbRevenue / totalAmount) * 100 : 0;
            
            return (
              <g key={park}>
                {/* USD Point */}
                <Tooltip
                  title={
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        USD: ${formatNumber(data[park].usdRevenue)} ({usdPercentage.toFixed(1)}%)
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        ETB: {formatNumber(data[park].etbRevenue)} ETB ({etbPercentage.toFixed(1)}%)
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        Total: ${formatNumber(data[park].usdRevenue)} + {formatNumber(data[park].etbRevenue)} ETB
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        Transactions: {data[park].transactionCount}
                      </Typography>
                    </Box>
                  }
                  arrow
                  placement="top"
                >
                  <circle
                    cx={x}
                    cy={yUsd}
                    r="5"
                    fill="#1976d2"
                    stroke="white"
                    strokeWidth="2"
                    style={{ cursor: 'pointer' }}
                  />
                </Tooltip>
                
                {/* ETB Point */}
                <Tooltip
                  title={
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        USD: ${formatNumber(data[park].usdRevenue)} ({usdPercentage.toFixed(1)}%)
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        ETB: {formatNumber(data[park].etbRevenue)} ETB ({etbPercentage.toFixed(1)}%)
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        Total: ${formatNumber(data[park].usdRevenue)} + {formatNumber(data[park].etbRevenue)} ETB
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        Transactions: {data[park].transactionCount}
                      </Typography>
                    </Box>
                  }
                  arrow
                  placement="top"
                >
                  <circle
                    cx={x}
                    cy={yEtb}
                    r="5"
                    fill="#2e7d32"
                    stroke="white"
                    strokeWidth="2"
                    style={{ cursor: 'pointer' }}
                  />
                </Tooltip>
                
                {/* Park Name Label */}
                <text
                  x={x}
                  y={chartHeight - padding.bottom + 20}
                  textAnchor="middle"
                  fontSize="10"
                  transform={`rotate(-45, ${x}, ${chartHeight - padding.bottom + 20})`}
                >
                  {park.length > 15 ? park.substring(0, 12) + '...' : park}
                </text>
              </g>
            );
          })}
          
          {/* Axes */}
          <line
            x1={padding.left}
            y1={padding.top}
            x2={padding.left}
            y2={chartHeight - padding.bottom}
            stroke="#999"
            strokeWidth="1.5"
          />
          <line
            x1={padding.left}
            y1={chartHeight - padding.bottom}
            x2={chartWidth - padding.right}
            y2={chartHeight - padding.bottom}
            stroke="#999"
            strokeWidth="1.5"
          />
          
          {/* Y-axis label */}
          <text
            x={20}
            y={chartHeight / 2}
            textAnchor="middle"
            fontSize="11"
            fill="#666"
            transform={`rotate(-90, 20, ${chartHeight / 2})`}
          >
            Revenue Amount
          </text>
        </svg>
        
        {/* Legend */}
        <Box sx={{ 
          mt: 4, 
          display: 'flex', 
          justifyContent: 'center', 
          gap: 4,
          borderTop: '1px solid #e0e0e0',
          pt: 2
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 30, height: 3, bgcolor: '#1976d2' }} />
            <Box sx={{ width: 10, height: 10, bgcolor: '#1976d2', borderRadius: '50%' }} />
            <Typography variant="caption">USD Revenue Trend</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 30, height: 3, bgcolor: '#2e7d32' }} />
            <Box sx={{ width: 10, height: 10, bgcolor: '#2e7d32', borderRadius: '50%' }} />
            <Typography variant="caption">ETB Revenue Trend</Typography>
          </Box>
        </Box>
        
        <Box sx={{ 
          width: '100%', 
          bgcolor: '#f5f5f5', 
          mt: 2,
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          p: 2,
          borderRadius: 1
        }}>
          <Typography variant="body2" color="textSecondary">
            Number of Parks: {parks.length}
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
            Total USD: ${formatNumber(totalUSD)} | Total ETB: {formatNumber(totalETB)} ETB
          </Typography>
        </Box>
      </Box>
    );
  };

  // Combined Bar Chart Component (USD and ETB together)
  const CombinedBarChart = ({ data }) => {
    const maxUsdValue = Math.max(...Object.values(data).map(d => d.usdRevenue), 0);
    const maxEtbValue = Math.max(...Object.values(data).map(d => d.etbRevenue), 0);
    const maxValue = Math.max(maxUsdValue, maxEtbValue);
    const parks = Object.keys(data);
    
    if (parks.length === 0) {
      return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">
            No data available
          </Typography>
        </Box>
      );
    }
    
    return (
      <Box sx={{ p: 2, overflowX: 'auto' }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
          Revenue Comparison by Park (USD vs ETB)
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 3, minHeight: 350, justifyContent: 'center', flexWrap: 'wrap' }}>
          {parks.map((park) => {
            const usdHeight = maxValue > 0 ? (data[park].usdRevenue / maxValue) * 220 : 0;
            const etbHeight = maxValue > 0 ? (data[park].etbRevenue / maxValue) * 220 : 0;
            const totalAmount = data[park].usdRevenue + data[park].etbRevenue;
            const usdPercentage = totalAmount > 0 ? (data[park].usdRevenue / totalAmount) * 100 : 0;
            const etbPercentage = totalAmount > 0 ? (data[park].etbRevenue / totalAmount) * 100 : 0;
            
            return (
              <Box key={park} sx={{ textAlign: 'center', minWidth: 120, cursor: 'pointer' }}>
                <Tooltip
                  title={
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        USD: ${formatNumber(data[park].usdRevenue)} ({usdPercentage.toFixed(1)}%)
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        ETB: {formatNumber(data[park].etbRevenue)} ETB ({etbPercentage.toFixed(1)}%)
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        Total: ${formatNumber(data[park].usdRevenue)} + {formatNumber(data[park].etbRevenue)} ETB
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        Transactions: {data[park].transactionCount}
                      </Typography>
                    </Box>
                  }
                  arrow
                  placement="top"
                >
                  <Box>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.5, justifyContent: 'center' }}>
                      {/* USD Bar */}
                      <Box sx={{ textAlign: 'center' }}>
                        <Box sx={{ 
                          height: usdHeight, 
                          width: '40px',
                          bgcolor: '#1976d2',
                          borderRadius: '4px 4px 0 0',
                          margin: '0 auto',
                          position: 'relative',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            opacity: 0.8,
                            transform: 'translateY(-5px)',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                          }
                        }} />
                        <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontSize: '10px', color: '#1976d2' }}>
                          USD
                        </Typography>
                      </Box>
                      
                      {/* ETB Bar */}
                      <Box sx={{ textAlign: 'center' }}>
                        <Box sx={{ 
                          height: etbHeight, 
                          width: '40px',
                          bgcolor: '#2e7d32',
                          borderRadius: '4px 4px 0 0',
                          margin: '0 auto',
                          position: 'relative',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            opacity: 0.8,
                            transform: 'translateY(-5px)',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                          }
                        }} />
                        <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontSize: '10px', color: '#2e7d32' }}>
                          ETB
                        </Typography>
                      </Box>
                    </Box>
                    
                    <Typography variant="caption" sx={{ mt: 1, display: 'block', fontWeight: 'bold' }}>
                      {park.length > 15 ? park.substring(0, 12) + '...' : park}
                    </Typography>
                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block', fontSize: '9px' }}>
                      ${formatNumber(data[park].usdRevenue)} | {formatNumber(data[park].etbRevenue)} ETB
                    </Typography>
                  </Box>
                </Tooltip>
              </Box>
            );
          })}
        </Box>
        
        {/* Legend */}
        <Box sx={{ 
          mt: 4, 
          display: 'flex', 
          justifyContent: 'center', 
          gap: 4,
          borderTop: '1px solid #e0e0e0',
          pt: 2
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 20, height: 20, bgcolor: '#1976d2', borderRadius: 1 }} />
            <Typography variant="caption">USD Revenue</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 20, height: 20, bgcolor: '#2e7d32', borderRadius: 1 }} />
            <Typography variant="caption">ETB Revenue</Typography>
          </Box>
        </Box>
        
        <Box sx={{ 
          width: '100%', 
          bgcolor: '#f5f5f5', 
          mt: 2,
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          p: 2,
          borderRadius: 1
        }}>
          <Typography variant="body2" color="textSecondary">
            Number of Parks: {parks.length}
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
            Total USD: ${formatNumber(totalUSD)} | Total ETB: {formatNumber(totalETB)} ETB
          </Typography>
        </Box>
      </Box>
    );
  };

  // Standard Chart Component for single currency
  const SingleCurrencyChart = ({ title, data, totalAmount, currencySymbol, chartType }) => {
    const maxValue = Math.max(...Object.values(data).map(d => d.totalRevenue), 0);
    const parks = Object.keys(data);
    
    if (Object.keys(data).length === 0) {
      return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">
            No data available for {title}
          </Typography>
        </Box>
      );
    }

    // Line Chart Component for single currency
    const LineChart = () => {
      const chartHeight = 300;
      const chartWidth = Math.max(600, parks.length * 70);
      const padding = { top: 20, right: 30, bottom: 60, left: 60 };
      
      return (
        <svg width="100%" height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
          {/* Grid lines */}
          {[0, 25, 50, 75, 100].map((percent) => {
            const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
            const value = (maxValue * percent) / 100;
            return (
              <g key={percent}>
                <line
                  x1={padding.left}
                  y1={y}
                  x2={chartWidth - padding.right}
                  y2={y}
                  stroke="#e0e0e0"
                  strokeWidth="1"
                  strokeDasharray="4"
                />
                <text
                  x={padding.left - 5}
                  y={y}
                  textAnchor="end"
                  fontSize="10"
                  fill="#666"
                >
                  {currencySymbol}{formatNumber(value)}
                </text>
              </g>
            );
          })}
          
          {/* Line */}
          <polyline
            points={parks.map((park, index) => {
              const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
              const y = chartHeight - padding.bottom - (data[park].totalRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
              return `${x},${y}`;
            }).join(' ')}
            fill="none"
            stroke={title.includes('USD') ? '#1976d2' : '#2e7d32'}
            strokeWidth="2"
          />
          
          {/* Points and labels */}
          {parks.map((park, index) => {
            const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
            const y = chartHeight - padding.bottom - (data[park].totalRevenue / maxValue) * (chartHeight - padding.top - padding.bottom);
            const percentage = totalAmount > 0 ? (data[park].totalRevenue / totalAmount) * 100 : 0;
            
            return (
              <g key={park}>
                <Tooltip
                  title={
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        Amount: {currencySymbol}{formatNumber(data[park].totalRevenue)}
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        Percentage: {percentage.toFixed(2)}%
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        Transactions: {data[park].transactionCount}
                      </Typography>
                    </Box>
                  }
                  arrow
                  placement="top"
                >
                  <circle
                    cx={x}
                    cy={y}
                    r="4"
                    fill={title.includes('USD') ? '#1976d2' : '#2e7d32'}
                    stroke="white"
                    strokeWidth="2"
                    style={{ cursor: 'pointer' }}
                  />
                </Tooltip>
                <text
                  x={x}
                  y={chartHeight - padding.bottom + 15}
                  textAnchor="middle"
                  fontSize="10"
                  transform={`rotate(-45, ${x}, ${chartHeight - padding.bottom + 15})`}
                >
                  {park.length > 12 ? park.substring(0, 10) + '...' : park}
                </text>
                <text
                  x={x}
                  y={y - 8}
                  textAnchor="middle"
                  fontSize="9"
                  fill="#666"
                >
                  {currencySymbol}{formatNumber(data[park].totalRevenue)}
                </text>
              </g>
            );
          })}
          
          {/* Axes */}
          <line
            x1={padding.left}
            y1={padding.top}
            x2={padding.left}
            y2={chartHeight - padding.bottom}
            stroke="#999"
            strokeWidth="1"
          />
          <line
            x1={padding.left}
            y1={chartHeight - padding.bottom}
            x2={chartWidth - padding.right}
            y2={chartHeight - padding.bottom}
            stroke="#999"
            strokeWidth="1"
          />
        </svg>
      );
    };

    // Bar Chart Component
    const BarChart = () => {
      return (
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 300, justifyContent: 'center', flexWrap: 'wrap' }}>
          {Object.entries(data).map(([park, parkData]) => {
            const height = maxValue > 0 ? (parkData.totalRevenue / maxValue) * 200 : 0;
            const percentage = totalAmount > 0 ? (parkData.totalRevenue / totalAmount) * 100 : 0;
            return (
              <Tooltip
                key={park}
                title={
                  <Box sx={{ p: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
                    <Typography variant="body2" sx={{ color: '#fff' }}>
                      Amount: {currencySymbol}{formatNumber(parkData.totalRevenue)}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#fff' }}>
                      Percentage: {percentage.toFixed(2)}%
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#fff' }}>
                      Transactions: {parkData.transactionCount}
                    </Typography>
                  </Box>
                }
                arrow
                placement="top"
              >
                <Box sx={{ textAlign: 'center', flex: 1, minWidth: 80, cursor: 'pointer' }}>
                  <Box sx={{ 
                    height: height, 
                    width: '60px',
                    bgcolor: title.includes('USD') ? '#1976d2' : '#2e7d32',
                    borderRadius: '4px 4px 0 0',
                    margin: '0 auto',
                    position: 'relative',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      opacity: 0.8,
                      transform: 'translateY(-5px)',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                    }
                  }} />
                  <Typography variant="caption" sx={{ mt: 1, display: 'block', fontWeight: 'bold' }}>
                    {park.length > 12 ? park.substring(0, 10) + '...' : park}
                  </Typography>
                  <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                    {currencySymbol}{formatNumber(parkData.totalRevenue)}
                  </Typography>
                </Box>
              </Tooltip>
            );
          })}
        </Box>
      );
    };

    // Pie Chart Component
    const PieChart = () => {
      let cumulativePercentage = 0;
      const colors = ['#2e7d32', '#1976d2', '#ff9800', '#9c27b0', '#f44336', '#00bcd4', '#795548', '#607d8b'];
      
      return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
          <Box sx={{ position: 'relative', width: 250, height: 250 }}>
            <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%' }}>
              {Object.entries(data).map(([park, parkData], index) => {
                const percentage = (parkData.totalRevenue / totalAmount) * 100;
                const startAngle = cumulativePercentage * 3.6;
                const endAngle = (cumulativePercentage + percentage) * 3.6;
                cumulativePercentage += percentage;
                
                const startRad = (startAngle - 90) * Math.PI / 180;
                const endRad = (endAngle - 90) * Math.PI / 180;
                
                const x1 = 50 + 40 * Math.cos(startRad);
                const y1 = 50 + 40 * Math.sin(startRad);
                const x2 = 50 + 40 * Math.cos(endRad);
                const y2 = 50 + 40 * Math.sin(endRad);
                
                const largeArc = percentage > 50 ? 1 : 0;
                
                return (
                  <Tooltip
                    key={park}
                    title={
                      <Box sx={{ p: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
                        <Typography variant="body2" sx={{ color: '#fff' }}>
                          Amount: {currencySymbol}{formatNumber(parkData.totalRevenue)}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#fff' }}>
                          Percentage: {percentage.toFixed(2)}%
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#fff' }}>
                          Transactions: {parkData.transactionCount}
                        </Typography>
                      </Box>
                    }
                    arrow
                    placement="top"
                  >
                    <path
                      d={`M 50 50 L ${x1} ${y1} A 40 40 0 ${largeArc} 1 ${x2} ${y2} Z`}
                      fill={colors[index % colors.length]}
                      stroke="white"
                      strokeWidth="1"
                      style={{ cursor: 'pointer' }}
                    />
                  </Tooltip>
                );
              })}
              <circle cx="50" cy="50" r="25" fill="white" />
            </svg>
          </Box>
          <Box sx={{ minWidth: 200 }}>
            {Object.entries(data).map(([park, parkData], index) => {
              const percentage = (parkData.totalRevenue / totalAmount) * 100;
              return (
                <Box key={park} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <Box sx={{ width: 12, height: 12, bgcolor: colors[index % colors.length], borderRadius: 1 }} />
                  <Typography variant="caption" sx={{ flex: 1 }}>
                    {park.length > 20 ? park.substring(0, 18) + '...' : park} ({percentage.toFixed(1)}%)
                  </Typography>
                  <Typography variant="caption" fontWeight="bold">
                    {currencySymbol}{formatNumber(parkData.totalRevenue)}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      );
    };

    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 2 }}>
          {title} - Total: {currencySymbol}{formatNumber(totalAmount)}
        </Typography>
        
        {chartType === 'line' && <LineChart />}
        {chartType === 'bar' && <BarChart />}
        {chartType === 'pie' && <PieChart />}
        
        <Box sx={{ 
          width: '100%', 
          bgcolor: '#f5f5f5', 
          mt: 2,
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          p: 2,
          borderRadius: 1
        }}>
          <Typography variant="body2" color="textSecondary">
            Number of Parks: {Object.keys(data).length}
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
            Total Revenue: {currencySymbol}{formatNumber(totalAmount)}
          </Typography>
        </Box>
      </Box>
    );
  };

  // Yearly Chart Dashboard Component
  const YearlyChartDashboard = () => {
    const [yearlyChartType, setYearlyChartType] = useState('line');
    const [yearlyCurrencyView, setYearlyCurrencyView] = useState('both');
    
    const yearlySummaryData = getYearlySummaryData();
    const parksListForYearly = [...new Set(filteredData.map(item => item.park_name).filter(Boolean))];
    
    const getYearlyDataForDisplay = () => {
      if (selectedParkForYearly !== "all") {
        return getYearlyDataForPark(selectedParkForYearly);
      }
      return yearlySummaryData;
    };
    
    const displayData = getYearlyDataForDisplay();
    
    const getChartTitle = () => {
      let title = "Yearly Revenue Trend";
      if (selectedParkForYearly !== "all") {
        title += ` - ${selectedParkForYearly}`;
      }
      if (yearlyCurrencyView === 'usd') {
        title += " (USD)";
      } else if (yearlyCurrencyView === 'etb') {
        title += " (ETB)";
      } else {
        title += " (USD + ETB)";
      }
      return title;
    };
    
    const getCurrencySymbol = () => {
      if (yearlyCurrencyView === 'usd') return "$";
      if (yearlyCurrencyView === 'etb') return "ETB";
      return yearlyCurrencyView === 'both' ? "$" : "";
    };
    
    const renderYearlyChart = () => {
      if (yearlyChartType === 'line') {
        return (
          <YearlyLineChart 
            title={getChartTitle()}
            yearlyData={displayData}
            currencySymbol={getCurrencySymbol()}
            currencyType={yearlyCurrencyView}
          />
        );
      } else {
        return (
          <YearlyBarChart 
            title={getChartTitle()}
            yearlyData={displayData}
            currencySymbol={getCurrencySymbol()}
            currencyType={yearlyCurrencyView}
          />
        );
      }
    };
    
    return (
      <Box sx={{ mt: 2, mb: 3 }}>
        {/* Controls for Yearly Chart */}
        <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Select Park</InputLabel>
                <Select
                  value={selectedParkForYearly}
                  onChange={(e) => setSelectedParkForYearly(e.target.value)}
                  label="Select Park"
                >
                  <MenuItem value="all">All Parks (Summary)</MenuItem>
                  {parksListForYearly.map((park) => (
                    <MenuItem key={park} value={park}>{park}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md={2}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" color="textSecondary">Chart Type:</Typography>
                <ToggleButtonGroup
                  value={yearlyChartType}
                  exclusive
                  onChange={(e, val) => val && setYearlyChartType(val)}
                  size="small"
                >
                  <ToggleButton value="line">
                    <Tooltip title="Line Chart"><ShowChartIcon fontSize="small" /></Tooltip>
                  </ToggleButton>
                  <ToggleButton value="bar">
                    <Tooltip title="Bar Chart"><BarChartIcon fontSize="small" /></Tooltip>
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Grid>
            
            <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
  <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
    Currency View:
  </Typography>
  <ToggleButtonGroup
    value={yearlyCurrencyView}
    exclusive
    onChange={(e, val) => val && setYearlyCurrencyView(val)}
    size="small"
    aria-label="currency view"
  >
    <ToggleButton value="both" aria-label="both currencies">
      Both
    </ToggleButton>
    <ToggleButton value="usd" aria-label="USD only">
      USD Only
    </ToggleButton>
    <ToggleButton value="etb" aria-label="ETB only">
      ETB Only
    </ToggleButton>
  </ToggleButtonGroup>
</Box>
            </Grid>
          </Grid>
        </Paper>
        
        {/* Yearly Chart Display */}
        <Paper elevation={1} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
          {Object.keys(displayData).length === 0 ? (
            <Box sx={{ p: 5, textAlign: 'center' }}>
              <Typography variant="body2" color="textSecondary">
                No yearly data available for the selected filters
              </Typography>
            </Box>
          ) : (
            renderYearlyChart()
          )}
        </Paper>
      </Box>
    );
  };

  // Main Chart Component
  const SimpleChart = () => {
    const combinedChartData = getCombinedChartData();
    const usdChartData = getChartDataByCurrency('USD');
    const etbChartData = getChartDataByCurrency('ETB');
    
    return (
        <Box sx={{ mt: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
  <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
    Currency View:
  </Typography>
  <ToggleButtonGroup
    value={chartCurrency}
    exclusive
    onChange={(e, val) => val && setChartCurrency(val)}
    size="small"
    aria-label="currency view"
    sx={{
      '& .MuiToggleButton-root': {
        borderColor: 'gray',
        color: 'gray',
        textTransform: 'none',
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: '#f5f5f5',
          borderColor: '#1976d2',
        },
        '&.Mui-selected': {
          backgroundColor: '#e0e0e0',
          color: 'black',
          borderColor: 'gray',
          '&:hover': {
            backgroundColor: '#e0e0e0',
          }
        }
      }
    }}
  >
    <ToggleButton value="both" aria-label="both currencies">
      Both
    </ToggleButton>
    <ToggleButton value="USD" aria-label="USD only">
      USD Only
    </ToggleButton>
    <ToggleButton value="ETB" aria-label="ETB only">
      ETB Only
    </ToggleButton>
  </ToggleButtonGroup>
</Box>
        
        <Paper elevation={1} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
          {chartCurrency === 'both' ? (
            chartType === 'bar' ? (
              <CombinedBarChart data={combinedChartData} />
            ) : chartType === 'line' ? (
              <CombinedLineChart data={combinedChartData} />
            ) : (
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Paper variant="outlined" sx={{ p: 1 }}>
                    <SingleCurrencyChart 
                      title="USD Revenue by Park"
                      data={usdChartData} 
                      totalAmount={totalUSD}
                      currencySymbol="$"
                      chartType={chartType}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper variant="outlined" sx={{ p: 1 }}>
                    <SingleCurrencyChart 
                      title="ETB Revenue by Park"
                      data={etbChartData} 
                      totalAmount={totalETB}
                      currencySymbol="ETB"
                      chartType={chartType}
                    />
                  </Paper>
                </Grid>
              </Grid>
            )
          ) : chartCurrency === 'USD' ? (
            <SingleCurrencyChart 
              title="USD Revenue by Park"
              data={usdChartData} 
              totalAmount={totalUSD}
              currencySymbol="$"
              chartType={chartType}
            />
          ) : (
            <SingleCurrencyChart 
              title="ETB Revenue by Park"
              data={etbChartData} 
              totalAmount={totalETB}
              currencySymbol="ETB"
              chartType={chartType}
            />
          )}
        </Paper>
      </Box>
    );
  };

  return (
    <Box sx={{ width: '100%', bgcolor: '#f5f5f5', minHeight: '100vh', p: 3 }}>
      {/* Header Section */}
      <Typography variant="h6" gutterBottom sx={{ color: '#1a237e', fontWeight: 'bold', textAlign: 'center', mb: 1 }}>
        Revenue Report Dashboard
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', mb: 3 }}>
        Track and analyze revenue across all industrial parks
      </Typography>
      
      {/* Summary Cards - Using abbreviated format */}
      <Grid container spacing={2} sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
        <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
            <CardContent sx={{ py: 1, '&:last-child': { pb: 1 }, textAlign: 'center' }}>
              <TrendingUpIcon sx={{ color: '#2e7d32', fontSize: 18 }} />
              <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem', display: 'block' }}>
                Total Revenue
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, my: 0.5 }}>
                <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 'normal', fontSize: '0.8rem' }}>
                  USD: ${formatNumberWithAbbreviation(totalUSD)}
                </Typography>
                <Box sx={{ width: '1px', height: '16px', bgcolor: '#ddd' }} />
                <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 'normal', fontSize: '0.8rem' }}>
                  ETB: {formatNumberWithAbbreviation(totalETB)} ETB
                </Typography>
              </Box>
              <Typography variant="caption" sx={{ color: '#999', fontSize: '0.65rem', display: 'block', mt: 0.5 }}>
                Across all parks
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
            <CardContent sx={{ py: 1, '&:last-child': { pb: 1 }, textAlign: 'center' }}>
              <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem', display: 'block' }}>
                Total Transactions
              </Typography>
              <Typography variant="body2" sx={{ my: 0.5, color: '#1976d2', fontWeight: 'normal', fontSize: '0.9rem' }}>
                {formatNumberWithAbbreviation(summaryStats.totalTransactions)}
              </Typography>
              <Typography variant="caption" sx={{ color: '#999', fontSize: '0.65rem', display: 'block', mt: 0.5 }}>
                All time
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
            <CardContent sx={{ py: 1, '&:last-child': { pb: 1 }, textAlign: 'center' }}>
              <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem', display: 'block' }}>
                Active Companies
              </Typography>
              <Typography variant="body2" sx={{ my: 0.5, color: '#1976d2', fontWeight: 'normal', fontSize: '0.9rem' }}>
                {formatNumberWithAbbreviation(summaryStats.uniqueCompanies)}
              </Typography>
              <Typography variant="caption" sx={{ color: '#999', fontSize: '0.65rem', display: 'block', mt: 0.5 }}>
                Currently active
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      
      {/* Filters Section */}
      <Paper elevation={2} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search by company, transaction ID..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: searchTerm && (
                  <InputAdornment position="end">
                    <ClearIcon
                      sx={{ cursor: 'pointer' }}
                      onClick={() => setSearchTerm("")}
                    />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Park</InputLabel>
              <Select
                value={selectedPark}
                onChange={(e) => setSelectedPark(e.target.value)}
                label="Park"
              >
                <MenuItem value="all">All Parks</MenuItem>
                {parksList.map((park) => (
                  <MenuItem key={park} value={park}>{park}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Currency</InputLabel>
              <Select
                value={selectedCurrency}
                onChange={(e) => setSelectedCurrency(e.target.value)}
                label="Currency"
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="usd">USD</MenuItem>
                <MenuItem value="birr">Birr</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={2}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                fullWidth
                variant="outlined"
                onClick={resetFilters}
                startIcon={<ClearIcon />}
                size="small"
                sx={{ 
                  textTransform: 'none',
                  borderColor: '#1976d2',
                  color: '#1976d2',
                  '&:hover': {
                    borderColor: '#1565c0',
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  },
                }}
              >
                Reset
              </Button>
              <Button
                fullWidth
                variant="contained"
                color="inherit"
                size="small"
                onClick={handleExportCSV}
                startIcon={<DownloadIcon />}
                sx={{ textTransform: 'none' }}
              >
                Export
              </Button>
            </Box>
          </Grid>
        </Grid>
        
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Year From</InputLabel>
              <Select
                value={startYear}
                onChange={(e) => setStartYear(e.target.value)}
                label="Year From"
              >
                {years.map((year) => (
                  <MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Year To</InputLabel>
              <Select
                value={endYear}
                onChange={(e) => setEndYear(e.target.value)}
                label="Year To"
              >
                {years.map((year) => (
                  <MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Month From</InputLabel>
              <Select
                value={startMonth}
                onChange={(e) => setStartMonth(e.target.value)}
                label="Month From"
              >
                {months.map((month) => (
                  <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Month To</InputLabel>
              <Select
                value={endMonth}
                onChange={(e) => setEndMonth(e.target.value)}
                label="Month To"
              >
                {months.map((month) => (
                  <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                Chart Type:
              </Typography>
              <ToggleButtonGroup
                value={chartType}
                exclusive
                onChange={handleChartTypeChange}
                size="small"
                aria-label="chart type"
              >
                <ToggleButton value="bar" aria-label="bar chart">
                  <Tooltip title="Bar Chart">
                    <BarChartIcon fontSize="small" />
                  </Tooltip>
                </ToggleButton>
                <ToggleButton value="line" aria-label="line chart">
                  <Tooltip title="Line Chart">
                    <ShowChartIcon fontSize="small" />
                  </Tooltip>
                </ToggleButton>
                <ToggleButton value="pie" aria-label="pie chart">
                  <Tooltip title="Pie Chart">
                    <PieChartIcon fontSize="small" />
                  </Tooltip>
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => setShowChart(!showChart)}
              sx={{ 
                minWidth: '100px',
                textTransform: 'none',
                borderColor: '#1976d2',
                color: '#1976d2',
                '&:hover': { 
                  borderColor: '#1976d2',
                  backgroundColor: '#f5f5f5',
                  color: '#1976d2'
                }
              }}
            >
              {showChart ? "Hide Chart" : "Show Chart"}
            </Button>
          </Grid>
        </Grid>
      </Paper>
      
      {/* Conditional Rendering: Show Chart OR Table */}
      {showChart ? (
        <>
          {/* Chart Type Toggle Buttons */}
          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
  variant={!showYearlyChart ? 'contained' : 'outlined'}
  size="small"
  onClick={() => setShowYearlyChart(false)}
  sx={{ 
    textTransform: 'none',
    minWidth: '120px',
    borderColor: '#1976d2',
    color: '#1976d2',
    ...(!showYearlyChart ? {
      backgroundColor: '#e0e0e0',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      }
    } : {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      }
    })
  }}
>
  By Park
</Button>

<Button
  variant={showYearlyChart ? 'contained' : 'outlined'}
  size="small"
  onClick={() => setShowYearlyChart(true)}
  sx={{ 
    textTransform: 'none',
    minWidth: '120px',
    borderColor: '#1976d2',
    color: '#1976d2',
    ...(showYearlyChart ? {
      backgroundColor: '#e0e0e0',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      }
    } : {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      }
    })
  }}
>
  Yearly Trend
</Button>
</Box>
          
          {!showYearlyChart ? (
            <SimpleChart />
          ) : (
            <YearlyChartDashboard />
          )}
        </>
      ) : (
        <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
              <CircularProgress />
              <Typography sx={{ ml: 2 }}>Loading revenue data...</Typography>
            </Box>
          ) : filteredData.length === 0 ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
              <Typography sx={{ color: 'text.secondary' }}>No revenue data available</Typography>
            </Box>
          ) : (
            <>
              <Box sx={{ p: 2, bgcolor: '#fafafa', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Revenue Records
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Showing {filteredData.length} of {revenueData.length} records
                </Typography>
              </Box>
              
              <TableContainer>
                <Table size="small">
                  <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                    <TableRow>
                      <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Transaction ID</TableCell>
                      <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Company Name</TableCell>
                      <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Park</TableCell>
                      <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Payment Mode</TableCell>
                      <TableCell align="right" sx={{ py: 1, fontWeight: 'bold' }}>Amount</TableCell>
                      <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Transaction Date</TableCell>
                      <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Revenue Type</TableCell>
                      <TableCell align="center" sx={{ py: 1, fontWeight: 'bold' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getCurrentPageData().map((row) => (
                      <TableRow key={row.id} hover>
                        <TableCell sx={{ py: 0.5 }}>{row.transaction_id}</TableCell>
                        <TableCell sx={{ py: 0.5 }}>{row.company_name}</TableCell>
                        <TableCell sx={{ py: 0.5 }}>{row.park_name}</TableCell>
                        <TableCell sx={{ py: 0.5 }}>{row.payment_mode}</TableCell>
                        <TableCell align="right" sx={{ py: 0.5, color: '#2e7d32', fontWeight: 'bold' }}>
                          {row.formattedAmount}
                        </TableCell>
                        <TableCell sx={{ py: 0.5 }}>{row.transaction_date_formatted}</TableCell>
                        <TableCell sx={{ py: 0.5 }}>{row.revenue_type}</TableCell>
                        <TableCell align="center" sx={{ py: 0.5 }}>
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleViewDetails(row)}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
              
              <Box sx={{ 
                p: 2, 
                bgcolor: '#fafafa', 
                borderTop: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: 3
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold' }}>
                    Summary: {`Total Records: ${filteredData.length}`} | {' '}
                    {`Total USD: $${formatNumber(totalUSD)}`} | {' '}
                    {`Total ETB: ${formatNumber(totalETB)} ETB`}
                  </Typography>
                </Box>
              </Box>
            </>
          )}
        </Paper>
      )}
      
      {/* Details Dialog */}
      <Dialog open={openDetailsDialog} onClose={() => setOpenDetailsDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" sx={{ color: 'black', fontWeight: 'normal' }}>
              Revenue Transaction Details
            </Typography>
            <IconButton onClick={() => setOpenDetailsDialog(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {selectedRevenue && (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Transaction ID:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedRevenue.transaction_id}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Company Name:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedRevenue.company_name}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Park Name:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedRevenue.park_name}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Payment Mode:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedRevenue.payment_mode}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Amount:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: '#2e7d32', fontWeight: 'bold' }}>
                      {selectedRevenue.formattedAmount}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Transaction Date:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedRevenue.transaction_date_formatted}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Revenue Type:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedRevenue.revenue_type}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Year/Month:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedRevenue.year} - {selectedRevenue.month}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Payment Status:
                    </Typography>
                    <Chip 
                      label={selectedRevenue.payment_status} 
                      size="small" 
                      color={selectedRevenue.payment_status === "Completed" ? "success" : "warning"}
                    />
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Invoice Number:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedRevenue.invoice_number}
                    </Typography>
                  </Box>
                </Grid>
                
                {selectedRevenue.description && (
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                      <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                        Description:
                      </Typography>
                      <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                        {selectedRevenue.description}
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>
          )}
        </DialogContent>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={() => setOpenDetailsDialog(false)} variant="outlined" sx={{ color: 'black', borderColor: '#ccc' }}>Close</Button>
        </Box>
      </Dialog>
    </Box>
  );
}
